import React, { useEffect, useRef, useState } from 'react'
import { FiDownload, FiRefreshCw } from 'react-icons/fi'
import { LocationOn, Lock, LockOpen } from '@mui/icons-material'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import CloseIcon from '@mui/icons-material/Close'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import BadgeIcon from '@mui/icons-material/Badge'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import InfoIcon from '@mui/icons-material/Info'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import VisibilityIcon from '@mui/icons-material/Visibility'
import BlockIcon from '@mui/icons-material/Block'
import VerifiedIcon from '@mui/icons-material/Verified'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt'
import NoAccountsIcon from '@mui/icons-material/NoAccounts'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import SearchIcon from '@mui/icons-material/Search'
import MyLocationIcon from '@mui/icons-material/MyLocation'
import PsychologyIcon from '@mui/icons-material/Psychology'
import TranslateIcon from '@mui/icons-material/Translate'
import { format } from 'date-fns'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CheckIcon from '@mui/icons-material/Check'
import PersonIcon from '@mui/icons-material/Person'
import ClearIcon from '@mui/icons-material/Clear'
import Box from '@mui/material/Box'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import dayjs from 'dayjs'
import api from '@/services/api'
import Notfound from '../../../../Notfound'
import { TableShimmer } from '../../../../ShimmerUI'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Pagination,
  Tooltip,
  TextField,
  InputAdornment,
  Grid,
  Divider,
  Chip,
  Avatar,
  Card,
  CardContent,
  Typography,
  Alert,
  Snackbar,
  Stack,
  Menu,
  MenuItem,
  Drawer,
  Autocomplete,
  CircularProgress,
  Select,
} from '@mui/material'
import PercentIcon from '@mui/icons-material/Percent'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import RowsPerPageDropdown from '../../RowsPerPageDropdown'
import { ProviderDetailsDialog } from '@/components/provider-details'
import TablePopup from '../../Admin/CommonComponent/TablePopup'
import { Plus } from 'lucide-react'
import { log } from 'console'
import { PendingApprovalReviewDialog } from '@/components/provider-details/PendingApprovalReviewDialog'
import { useGooglePlaces } from '@/hooks/useGooglePlaces'

import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import OpenPatientAddDialog from '@/components/Agency/OpenPatientAddDialog'
import DocuSignSigner from '../../DocSign'
import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import AgencyDocuSignSigner from './AgencyDocuSignSigner'
import { InfoPopup, AreYouSurePopup } from '@/components/Popup'
import { useAuth } from '@/hooks/useAuth'
export interface PaymentMethod {
  _id: string
  patientId: string
  cardBrand: string
  last4: string
  expMonth: string
  expYear: string
  cardOwner: string
  isDefault: boolean
  isDeleted: boolean
  createdAt: string
  updatedAt: string
  __v: number
}
const dropdownZIndex = 9999

// API always returns isActive: true; the agency enable/disable toggle is reflected in `status` instead.
const isPatientActive = (patient: any) => patient?.status !== 'inactive'

const getAutocompletePopperProps = (zIndex: number = dropdownZIndex) => ({
  popper: {
    sx: {
      zIndex: `${zIndex} !important`,
    },
  },
  paper: {
    sx: {
      zIndex: `${zIndex} !important`,
    },
  },
})

// Stripe Card Input Component (inner component that uses Stripe hooks)
interface StripeCardInputInnerProps {
  cardholderName: string
  onCardholderNameChange: (name: string) => void
  cardComplete: boolean
  onCardCompleteChange: (complete: boolean) => void
  selectedPaymentMethod: PaymentMethod | null
  onStripeReady: (stripe: any, elements: any) => void
  isSaving: boolean
}

const StripeCardInputInner: React.FC<StripeCardInputInnerProps> = ({
  cardholderName,
  onCardholderNameChange,
  cardComplete,
  onCardCompleteChange,
  selectedPaymentMethod,
  onStripeReady,
  isSaving,
}) => {
  const stripe = useStripe()
  const elements = useElements()

  // Expose stripe and elements instances to parent
  React.useEffect(() => {
    if (stripe && elements) {
      onStripeReady(stripe, elements)
    }
  }, [stripe, elements, onStripeReady])

  const handleCardElementChange = (event: any) => {
    onCardCompleteChange(event.complete)
  }

  const cardElementOptions = {
    disableLink: true,
    hidePostalCode: true,
    style: {
      base: {
        fontSize: '14px',
        color: '#424770',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  }

  // If a saved payment method is selected, show its details instead of card input
  if (selectedPaymentMethod) {
    return (
      <div className="p-3 border border-gray-200 rounded-lg bg-gray-50">
        <div className="text-sm font-medium text-gray-700">
          Selected Payment Method
        </div>
        <div className="mt-1 text-xs text-gray-600">
          {selectedPaymentMethod.cardBrand.toUpperCase()} ****{' '}
          {selectedPaymentMethod.last4} ({selectedPaymentMethod.cardOwner})
        </div>
      </div>
    )
  }

  return (
    <div className="gap-4 space-y-4">
      <TextField
        size="small"
        label="Cardholder Name*"
        fullWidth
        value={cardholderName}
        onChange={e => onCardholderNameChange(e.target.value)}
        disabled={isSaving || !stripe}
        style={{
          marginBottom: '1rem',
        }}
      />
      <div
        className="p-3 border border-gray-300 rounded-lg"
        style={{
          borderColor: cardComplete ? '#3BAE78' : undefined,
        }}
      >
        {stripe && elements && (
          <CardElement
            options={cardElementOptions}
            onChange={handleCardElementChange}
          />
        )}
      </div>
      <Alert
        severity="info"
        icon={<InfoIcon />}
        sx={{
          borderRadius: 2,
          fontWeight: 600,
          fontSize: '0.8rem',
          bgcolor: '#e8f4fd',
          color: '#004b8f',
          border: '1px solid #b6dcf9',
          alignItems: 'center',
          lineHeight: 1.5,
          '& .MuiAlert-icon': {
            color: '#0070d2',
            fontSize: '1.25rem',
          },
        }}
      >
        We securely collect your card details to reserve your session. Rest
        assured, no payment will be deducted now. Charges will only be applied
        after your session is completed, following Stripe’s secure payment
        guidelines.
      </Alert>
    </div>
  )
}

// Wrapper component with Elements provider
interface StripeCardInputProps {
  cardholderName: string
  onCardholderNameChange: (name: string) => void
  cardComplete: boolean
  onCardCompleteChange: (complete: boolean) => void
  selectedPaymentMethod: PaymentMethod | null
  onStripeReady: (stripe: any, elements: any) => void
  isSaving: boolean
}
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)
export const StripeCardInput: React.FC<StripeCardInputProps> = props => {
  return (
    <Elements stripe={stripePromise}>
      <StripeCardInputInner {...props} />
    </Elements>
  )
}

const AgencyPatientManagment: React.FC = () => {
  const { hasPermission } = useAuth()
  const prevSize = sessionStorage.getItem('prevSize')
  const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
  const [pageSize, setPageSize] = useState(10)
  const [services, setServices] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loadingForShimmer, setLoadingForShimmer] = useState(true)
  const [patients, setPatients] = useState([])
  const [invitationsList, setInvitationsList] = useState([])
  const [totalInvitations, setTotalInvitations] = useState(0)
  const [pendingApprovalsList, setPendingApprovalsList] = useState<any[]>([])
  const [pendingApprovalsLoading, setPendingApprovalsLoading] = useState(false)
  const [openApprovalReview, setOpenApprovalReview] = useState(false)
  const [selectedApproval, setSelectedApproval] = useState<any>(null)

  const [insuranceSearchTerm, setInsuranceSearchTerm] = useState('')
  const [insuranceOptions, setInsuranceOptions] = useState<any[]>([])
  const [insuranceLoading, setInsuranceLoading] = useState(false)

  // Fetch insurance options from API (debounced)
  useEffect(() => {
    const trimmed = insuranceSearchTerm.trim()
    if (!trimmed) {
      setInsuranceOptions([])
      return
    }
    setInsuranceLoading(true)
    const handler = setTimeout(() => {
      fetchInsuranceOptions(trimmed)
    }, 400)

    return () => clearTimeout(handler)
  }, [insuranceSearchTerm])

  // const fetchInsuranceOptions = async (search: string) => {
  //   try {
  //     // Updated endpoint as per user instruction
  //     const response = await api.get('/payers/all', { params: { search } })
  //     setInsuranceOptions(response?.data?.data || [])
  //   } catch (error) {
  //     setInsuranceOptions([])
  //   } finally {
  //     setInsuranceLoading(false)
  //   }
  // }
  const fetchInsuranceOptions = async (search: string) => {
    try {
      const response = await api.get('/payers/all', { params: { search } })

      const data = response?.data || []

      setInsuranceOptions(data)
      setShowInsuranceDropdown(data.length > 0)
    } catch (error) {
      setInsuranceOptions([])
      setShowInsuranceDropdown(false)
    } finally {
      setInsuranceLoading(false)
    }
  }

  const [error, setError] = useState('')
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [selectedAccountStatus, setSelectedAccountStatus] = useState('')
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [licenseExpiryDate, setLicenseExpiryDate] = useState<Date | null>(null)
  const [selectedInsurance, setSelectedInsurance] = useState<string>('')
  const [selectedSpecialization, setSelectedSpecialization] =
    useState<string>('')
  const [selectedGender, setSelectedGender] = useState<string>('')

  const [totalRecords, setTotalRecords] = useState(0)
  const [totalActiveRecords, setTotalActiveRecords] = useState(0)
  const [unassignRecords, setUnassignRecords] = useState(0)
  const [totalInvitationRecords, setTotalInvitationRecords] = useState(0)

  const [openToggle, setOpenToggle] = useState(false) // Dialog open state
  const [openPatientStatusDialog, setOpenPatientStatusDialog] = useState(false)
  const [patientStatusTarget, setPatientStatusTarget] = useState<any>(null)
  const [patientStatusCurrent, setPatientStatusCurrent] =
    useState<boolean>(false)
  const [sortField, setSortField] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')
  const [selectedTherapistId, setSelectedTherapistId] = useState<string | null>(
    null
  ) // Selected therapist's ID
  const [isActive, setIsActive] = useState<boolean>(false) // Current status of the therapist
  const [loading, setLoading] = useState<boolean>(false) // Loading state during API request
  const [exportLoading, setExportLoading] = useState<boolean>(false) // Loading state for export
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false) // Commission dialog state
  const [monthlyCommission, setMonthlyCommission] = useState<string>('') // Monthly commission value
  const [yearlyCommission, setYearlyCommission] = useState<string>('') // Yearly commission value
  const [providerFeeDiscountPercent, setProviderFeeDiscountPercent] =
    useState<string>('') // Provider fee discount percentage
  const [commissionLoading, setCommissionLoading] = useState<boolean>(false) // Loading state for commission update
  const [openVerificationDialog, setOpenVerificationDialog] = useState(false) // Verification dialog state
  const [selectedProvider, setSelectedProvider] = useState<any>(null) // Selected provider for verification
  const [approveLoading, setApproveLoading] = useState<boolean>(false) // Loading state for approve action
  const [blockLoading, setBlockLoading] = useState<boolean>(false) // Loading state for block action
  const [patientStatusLoading, setPatientStatusLoading] =
    useState<boolean>(false) // Loading state for patient status update
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([])
  // Assign Provider dialog state
  const [openAssignProviderDialog, setOpenAssignProviderDialog] =
    useState(false)
  const [allAgencyProviders, setAllAgencyProviders] = useState<any[]>([])
  const [assignProviderLoading, setAssignProviderLoading] = useState(false)
  const [assignProviderSelected, setAssignProviderSelected] =
    useState<any>(null)
  const [assignProviderSubmitting, setAssignProviderSubmitting] =
    useState(false)

  const [openBlockReasonDialog, setOpenBlockReasonDialog] = useState(false) // Block reason dialog state
  const [blockReason, setBlockReason] = useState<string>('') // Block reason text
  const [openProviderDetailsDialog, setOpenProviderDetailsDialog] =
    useState(false) // Provider details (read-only) dialog state
  const [selectedProviderForDetails, setSelectedProviderForDetails] =
    useState<any>(null) // Selected provider for details view
  const [openApprovalDrawer, setOpenApprovalDrawer] = useState<boolean>(false) // Open state for pending approvals drawer
  const [selectedApprovalForDrawer, setSelectedApprovalForDrawer] =
    useState<any>(null) // Selected pending approval for review drawer
  const [openReverifyDialog, setOpenReverifyDialog] = useState(false) // Re-verification dialog state
  const [reverifyProviderId, setReverifyProviderId] = useState<string | null>(
    null
  )
  const [reverifyProviderName, setReverifyProviderName] = useState<string>('')
  const [reverifyLoading, setReverifyLoading] = useState<boolean>(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [selectedProviderForDelete, setSelectedProviderForDelete] =
    useState<any>(null)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedTherapistForMenu, setSelectedTherapistForMenu] =
    useState<any>(null)

  const [agencySelectedPatient, setAgencySelectedPatient] = useState<any>(null)
  const [openPatientProfileDialog, setOpenPatientProfileDialog] =
    useState(false)
  const [selectedPatientProfile, setSelectedPatientProfile] =
    useState<any>(null)
  console.log('selectedPatientProfile', selectedPatientProfile)

  const [openAddSessionChoiceDialog, setOpenAddSessionChoiceDialog] =
    useState(false)
  const [openNoTherapistPopup, setOpenNoTherapistPopup] = useState(false)
  const [openRemoveAgencyConfirm, setOpenRemoveAgencyConfirm] = useState(false)
  const [isRemovingPatient, setIsRemovingPatient] = useState(false)
  const [openRemoveInvitationConfirm, setOpenRemoveInvitationConfirm] =
    useState(false)
  const [isRemovingInvitation, setIsRemovingInvitation] = useState(false)
  const [openInsuranceDialog, setOpenInsuranceDialog] = useState(false)
  const [patientInsurancesLoading, setPatientInsurancesLoading] =
    useState(false)
  const [patientInsurances, setPatientInsurances] = useState<any[]>([])
  const [selectedInsuranceIndex, setSelectedInsuranceIndex] = useState(0)

  const [showInsuranceDropdown, setShowInsuranceDropdown] = useState(false)

  // Direct Session Dialog State
  const [openDirectSessionDialog, setOpenDirectSessionDialog] = useState(false)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const [dsMonthOffset, setDsMonthOffset] = useState(0)
  const dsMonthStart = new Date(
    today.getFullYear(),
    today.getMonth() + dsMonthOffset,
    1
  )
  const dsDaysInMonth = new Date(
    dsMonthStart.getFullYear(),
    dsMonthStart.getMonth() + 1,
    0
  ).getDate()
  const dsMonthDates: (Date | null)[] = (() => {
    const arr: (Date | null)[] = []
    const firstDay = dsMonthStart.getDay()
    for (let i = 0; i < firstDay; i++) arr.push(null)
    for (let i = 1; i <= dsDaysInMonth; i++)
      arr.push(new Date(dsMonthStart.getFullYear(), dsMonthStart.getMonth(), i))
    return arr
  })()
  const [dsSelectedDate, setDsSelectedDate] = useState<Date | null>(today)
  const [dsSlots, setDsSlots] = useState<any[]>([])
  const [dsLoadingSlots, setDsLoadingSlots] = useState(false)
  const [dsSelectedSlots, setDsSelectedSlots] = useState<
    Record<string, { slotId: string; startTime: string; endTime: string }>
  >({})
  const [dsPaymentMethod, setDsPaymentMethod] = useState<
    'insurance' | 'out_of_pocket' | ''
  >('')
  const [dsSubmitting, setDsSubmitting] = useState(false)
  const [dsSnackbar, setDsSnackbar] = useState<{
    open: boolean
    message: string
    severity: 'success' | 'error' | 'warning' | 'info'
  }>({ open: false, message: '', severity: 'success' })

  // DS dialog insurance & card state (shares fetch fns with Add Contract)
  const [dsSelectedInsuranceId, setDsSelectedInsuranceId] = useState('')
  const [dsSelectedPaymentMethodId, setDsSelectedPaymentMethodId] = useState('')
  const [dsCardholderName, setDsCardholderName] = useState('')
  const [dsNewInsuranceName, setDsNewInsuranceName] = useState('')
  const [dsPolicyId, setDsPolicyId] = useState('')
  const [dsPayerId, setDsPayerId] = useState('')

  const showDsMessage = (
    message: string,
    severity: 'success' | 'error' | 'warning' | 'info' = 'success'
  ) => {
    setDsSnackbar({ open: true, message, severity })
  }
  const [selectedServiceId, setSelectedServiceId] = useState('')

  const dsPad = (n: number) => String(n).padStart(2, '0')
  const dsFormatDateKey = (d: Date) =>
    `${d.getFullYear()}-${dsPad(d.getMonth() + 1)}-${dsPad(d.getDate())}`
  const dsFormatDateForAPI = (d: Date) => {
    const y = d.getFullYear()
    const m = dsPad(d.getMonth() + 1)
    const day = dsPad(d.getDate())
    return `${y}-${m}-${day}`
  }
  const dsFormatDateLong = (d: Date) =>
    d.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
  const dsIsPastDate = (d: Date) => {
    const todayOnly = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    )
    const compare = new Date(d.getFullYear(), d.getMonth(), d.getDate())
    return compare < todayOnly
  }
  const dsHandleSelectSlot = (date: Date, slot: any) => {
    const dateKey = dsFormatDateKey(date)
    const start = slot.startTime
    const end = slot.endTime
    if (
      dsSelectedSlots[dateKey]?.startTime === start &&
      dsSelectedSlots[dateKey]?.endTime === end
    ) {
      const copy = { ...dsSelectedSlots }
      delete copy[dateKey]
      setDsSelectedSlots(copy)
      return
    }
    if (
      !dsSelectedSlots[dateKey] &&
      Object.keys(dsSelectedSlots).length >= 10
    ) {
      showDsMessage('You can add up to 10 sessions at a time.', 'warning')
      return
    }
    setDsSelectedSlots(prev => ({
      ...prev,
      [dateKey]: { slotId: slot._id, startTime: start, endTime: end },
    }))
  }
  const dsRemoveSlot = (dateKey: string) => {
    const copy = { ...dsSelectedSlots }
    delete copy[dateKey]
    setDsSelectedSlots(copy)
  }
  const saveNewCardViaStripeHelper = async (
    stripe: any,
    elements: any,
    name: string,
    patientId: string
  ): Promise<string | null> => {
    if (!stripe || !elements) {
      throw new Error('Stripe is not initialized')
    }

    const cardElement = elements.getElement(CardElement)
    if (!cardElement) {
      throw new Error('Card element not found')
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: name,
      },
    })

    if (error) {
      throw new Error(error.message)
    }

    if (!paymentMethod) {
      throw new Error('Failed to create payment method')
    }

    const payload = {
      cardOwner: name,
      cardBrand: paymentMethod.card?.brand || 'unknown',
      last4: paymentMethod.card?.last4 || '',
      expMonth: paymentMethod.card?.exp_month || 0,
      expYear: paymentMethod.card?.exp_year || 0,
      isDefault: false,
      stripePaymentMethodId: paymentMethod.id,
      patientId: patientId,
    }

    const response = await api.post('agency/payment-methods', payload)

    const cardData = response.data?.card || response.data?.data || response.data
    return cardData?._id || null
  }

  const handleDirectSessionSubmit = async () => {
    if (Object.keys(dsSelectedSlots).length === 0) {
      showDsMessage('Please select at least one slot', 'error')
      return
    }
    if (!dsPaymentMethod) {
      showDsMessage('Please select a payment method', 'error')
      return
    }
    if (!agencySelectedPatient?._id) {
      showDsMessage('No patient selected', 'error')
      return
    }

    // Validation for out_of_pocket
    if (dsPaymentMethod === 'out_of_pocket') {
      if (!dsSelectedPaymentMethodId) {
        if (!dsCardholderName.trim()) {
          showDsMessage('Cardholder name is required for new card.', 'error')
          return
        }
        if (!cardComplete) {
          showDsMessage('Please complete card details.', 'error')
          return
        }
      }
    }

    // Validation for insurance
    if (dsPaymentMethod === 'insurance') {
      if (!dsSelectedInsuranceId && !dsNewInsuranceName.trim()) {
        showDsMessage(
          'Please select a saved insurance or search a new one.',
          'error'
        )
        return
      }
      if (dsNewInsuranceName.trim() && !dsPolicyId.trim()) {
        showDsMessage('Member / Policy ID is required.', 'error')
        return
      }
    }

    let finalPaymentMethodId: string | undefined = undefined

    try {
      setDsSubmitting(true)

      if (dsPaymentMethod === 'out_of_pocket') {
        if (dsSelectedPaymentMethodId) {
          finalPaymentMethodId = dsSelectedPaymentMethodId
        } else {
          setIsSavingNewCard(true)
          try {
            const savedId = await saveNewCardViaStripeHelper(
              stripeInstance,
              elementsInstance,
              dsCardholderName,
              agencySelectedPatient._id
            )
            if (!savedId) {
              showDsMessage('Failed to save card. Please try again.', 'error')
              setIsSavingNewCard(false)
              setDsSubmitting(false)
              return
            }
            finalPaymentMethodId = savedId
            // Refresh payment methods for this patient
            fetchAcPaymentMethods(agencySelectedPatient._id)
          } catch (error: any) {
            console.error('Error saving card:', error)
            showDsMessage(error.message || 'Failed to save card.', 'error')
            setIsSavingNewCard(false)
            setDsSubmitting(false)
            return
          } finally {
            setIsSavingNewCard(false)
          }
        }
      }

      const bookings = Object.entries(dsSelectedSlots).map(
        ([dateKey, slot]) => {
          const parts = dateKey.split('-').map(Number)
          const dateObj = new Date(parts[0], parts[1] - 1, parts[2])
          return {
            date: dsFormatDateForAPI(dateObj),
            slot: `${slot.startTime}-${slot.endTime}`,
          }
        }
      )

      let resolvedPayerId = dsPayerId
      if (!resolvedPayerId && dsNewInsuranceName) {
        const matchedOption = insuranceOptions.find(
          opt =>
            (opt.payer_name || opt.name || '').toLowerCase() ===
            dsNewInsuranceName.toLowerCase()
        )
        if (matchedOption) {
          resolvedPayerId = matchedOption._id
        }
      }

      const payload = {
        patientId: agencySelectedPatient._id,
        member_id: agencySelectedPatient._id,
        therapistId: agencySelectedPatient.therapistId?._id,
        bookings,
        payment_method: dsPaymentMethod,
        serviceId: selectedServiceId,
        ...(dsPaymentMethod === 'out_of_pocket' && finalPaymentMethodId
          ? { payment_method_id: finalPaymentMethodId }
          : {}),
        ...(dsPaymentMethod === 'insurance'
          ? (() => {
              const savedIns = acInsurances.find(
                ins => ins._id === dsSelectedInsuranceId
              )
              return {
                insurance_card_id: dsSelectedInsuranceId || null,
                payer_id: dsSelectedInsuranceId
                  ? savedIns?.payer_id || savedIns?.payerId || null
                  : resolvedPayerId || null,
                insuranceName: dsSelectedInsuranceId
                  ? savedIns?.insuranceName ||
                    savedIns?.payer_name ||
                    savedIns?.name ||
                    null
                  : dsNewInsuranceName || null,
                policyNumber: dsSelectedInsuranceId
                  ? savedIns?.policyNumber || savedIns?.policy_number || null
                  : dsPolicyId || null,
                policy_id: dsSelectedInsuranceId
                  ? savedIns?.policyNumber || savedIns?.policy_number || null
                  : dsPolicyId || null,
              }
            })()
          : {}),
      }

      const res = await api.post('/contracts/add-session', payload)
      showDsMessage(
        res?.data?.message || 'Session(s) added successfully!',
        'success'
      )
      setTimeout(() => {
        setOpenDirectSessionDialog(false)
        setDsSelectedSlots({})
        setDsSelectedDate(today)
        setDsPaymentMethod('')
        setDsMonthOffset(0)
        setDsSelectedPaymentMethodId('')
        setDsSelectedInsuranceId('')
        setDsCardholderName('')
        setDsNewInsuranceName('')
        setDsPolicyId('')
        setDsPayerId('')
        setSelectedPaymentMethod(null)
      }, 1200)
    } catch (err: any) {
      showDsMessage(
        err?.response?.data?.message ||
          'Failed to add session. Please try again.',
        'error'
      )
    } finally {
      setDsSubmitting(false)
    }
  }

  // ───── Add Contract Dialog State ─────
  const [openAddContractDialog, setOpenAddContractDialog] = useState(false)
  const [acSessionsCount, setAcSessionsCount] = useState('')
  const [acPaymentType, setAcPaymentType] = useState<
    'insurance' | 'cash' | 'copay'
  >('insurance')
  const [acFirstName, setAcFirstName] = useState('')
  const [acLastName, setAcLastName] = useState('')
  const [acEmail, setAcEmail] = useState('')
  const [acPhone, setAcPhone] = useState('')
  const [acDob, setAcDob] = useState('')
  const [acGender, setAcGender] = useState('')
  const [acAddress, setAcAddress] = useState('')
  const [acState, setAcState] = useState('')
  const [acCity, setAcCity] = useState('')
  const [acAgreed, setAcAgreed] = useState(false)
  const [acSubmitting, setAcSubmitting] = useState(false)
  const [acSnackbar, setAcSnackbar] = useState<{
    open: boolean
    message: string
    severity: 'success' | 'error' | 'warning' | 'info'
  }>({ open: false, message: '', severity: 'success' })
  const showAcMessage = (
    message: string,
    severity: 'success' | 'error' | 'warning' | 'info' = 'success'
  ) => setAcSnackbar({ open: true, message, severity })

  // Insurance & Card state for contract dialog
  const [acInsurances, setAcInsurances] = useState<any[]>([])
  const [acPaymentMethods, setAcPaymentMethods] = useState<any[]>([])
  const [acSelectedInsuranceId, setAcSelectedInsuranceId] = useState('')
  const [acSelectedPaymentMethodId, setAcSelectedPaymentMethodId] = useState('')
  const [acCardholderName, setAcCardholderName] = useState('')
  const [acNewInsuranceName, setAcNewInsuranceName] = useState('')
  const [acPolicyId, setAcPolicyId] = useState('')
  const [acPayerId, setAcPayerId] = useState('')
  const [cardholderName, setCardholderName] = useState('')
  const [cardComplete, setCardComplete] = useState(false)
  const [paymentMethodId, setPaymentMethodId] = useState<string | null>(null)
  const [stripeInstance, setStripeInstance] = useState<any>(null)
  const [elementsInstance, setElementsInstance] = useState<any>(null)
  const [isSavingNewCard, setIsSavingNewCard] = useState(false)
  // Sign Contract (DocuSign) state
  const [openSignContractDialog, setOpenSignContractDialog] = useState(false)
  const [signContractId, setSignContractId] = useState('')

  const fetchAcInsurances = async (patientId: string) => {
    try {
      const res = await api.get(
        `/patient/insurance/patient-insurance/${patientId}`
      )
      const data = res?.data?.data || res?.data || []
      setAcInsurances(Array.isArray(data) ? data : [data])
    } catch {
      setAcInsurances([])
    }
  }

  const fetchAcPaymentMethods = async (patientId: string) => {
    try {
      const res = await api.get(
        `/agency/payment-methods?page=1&limit=20&patientId=${patientId}`
      )
      setAcPaymentMethods(res?.data?.data || [])
    } catch {
      setAcPaymentMethods([])
    }
  }

  const handlePaymentMethodChange = (method: PaymentMethod | null) => {
    setSelectedPaymentMethod(method)
    if (method) {
      // Clear card fields when a saved payment method is selected
      // We'll use payment_method_id instead of card details
      setCardholderName('')
      setCardComplete(false)
    } else {
      // Clear card fields when no payment method is selected
      setCardholderName('')
      setCardComplete(false)
    }
  }

  const openContractDialogForPatient = (patient: any) => {
    setAcFirstName(patient?.firstName || '')
    setAcLastName(patient?.lastName || '')
    setAcEmail(patient?.email || '')
    setAcPhone(patient?.phone || patient?.phoneNumber || '')
    setAcDob(patient?.dob || patient?.dateOfBirth || '')
    setAcGender(patient?.gender || '')
    setAcAddress(patient?.addressLine1 || patient?.address || '')
    setAcState(patient?.state || '')
    setAcCity(patient?.city || '')
    setAcSessionsCount('')
    setAcPaymentType('insurance')
    setAcAgreed(false)
    setAcSelectedInsuranceId('')
    setAcSelectedPaymentMethodId('')
    setAcCardholderName('')
    setAcNewInsuranceName('')
    setAcPolicyId('')
    setAcPayerId('')
    if (patient?._id) {
      fetchAcInsurances(patient._id)
      fetchAcPaymentMethods(patient._id)
    }
    setOpenAddContractDialog(true)
  }

  const handleAddContractSubmit = async () => {
    const errs: string[] = []
    if (!acSessionsCount || Number(acSessionsCount) <= 0)
      errs.push('Number of sessions is required.')
    if (!acFirstName.trim()) errs.push('First name is required.')
    if (!acLastName.trim()) errs.push('Last name is required.')
    if (!acEmail.trim()) errs.push('Email is required.')
    if (!acPhone.trim()) errs.push('Phone is required.')
    if (!acAgreed) errs.push('You must accept the policies to proceed.')
    if (!selectedServiceId) errs.push('Please select a service type.')

    // Payment specific validations for Cash/Copay
    if (acPaymentType === 'cash' || acPaymentType === 'copay') {
      if (!selectedPaymentMethod) {
        if (!cardholderName.trim()) errs.push('Cardholder name is required.')
        if (!cardComplete) errs.push('Please complete card details.')
      }
    }

    // Payment specific validations for Insurance
    if (acPaymentType === 'insurance' || acPaymentType === 'copay') {
      if (!acSelectedInsuranceId && !acNewInsuranceName.trim()) {
        errs.push(
          'Please select an insurance provider or search for a new one.'
        )
      }
      if (acNewInsuranceName.trim() && !acPolicyId.trim()) {
        errs.push('Member / Policy ID is required.')
      }
    }

    if (errs.length > 0) {
      showAcMessage(errs[0], 'error')
      return
    }

    const therapistObj = agencySelectedPatient?.therapistId
    const therapistIdStr =
      typeof therapistObj === 'string' ? therapistObj : therapistObj?._id || ''
    const serviceObj = therapistIdPackage?.find(
      (s: any) => s._id === selectedServiceId
    )

    let finalPaymentMethodId: string | undefined = undefined

    try {
      setAcSubmitting(true)

      if (acPaymentType === 'cash' || acPaymentType === 'copay') {
        if (selectedPaymentMethod) {
          finalPaymentMethodId = selectedPaymentMethod._id
        } else {
          setIsSavingNewCard(true)
          try {
            const savedId = await saveNewCardViaStripeHelper(
              stripeInstance,
              elementsInstance,
              cardholderName,
              agencySelectedPatient?._id
            )
            if (!savedId) {
              showAcMessage('Failed to save card. Please try again.', 'error')
              setIsSavingNewCard(false)
              setAcSubmitting(false)
              return
            }
            finalPaymentMethodId = savedId
            // Refresh payment methods for this patient
            fetchAcPaymentMethods(agencySelectedPatient?._id)
          } catch (error: any) {
            console.error('Error saving card:', error)
            showAcMessage(error.message || 'Failed to save card.', 'error')
            setIsSavingNewCard(false)
            setAcSubmitting(false)
            return
          } finally {
            setIsSavingNewCard(false)
          }
        }
      }

      let resolvedAcPayerId = acPayerId
      if (!resolvedAcPayerId && acNewInsuranceName) {
        const matchedOption = insuranceOptions.find(
          opt =>
            (opt.payer_name || opt.name || '').toLowerCase() ===
            acNewInsuranceName.toLowerCase()
        )
        if (matchedOption) {
          resolvedAcPayerId = matchedOption._id
        }
      }

      const payload = {
        patient_id: agencySelectedPatient?._id,
        therapist_id: therapistIdStr,
        patientFirstname: acFirstName,
        patientLastname: acLastName,
        patientEmail: acEmail,
        patientPhone: acPhone,
        patientDob: acDob,
        patientGender: acGender,
        patientAddress: acAddress,
        patientCity: acCity,
        patientState: acState,
        session_no: acSessionsCount.toString(),
        booking_for: 'self',
        member_id: agencySelectedPatient?._id,
        is_agree: acAgreed,
        payment_method_type: acPaymentType === 'cash' ? 'card' : acPaymentType,
        service_id: selectedServiceId,
        contract_amount: serviceObj?.rate || serviceObj?.price || 0,
        session_length:
          serviceObj?.duration || serviceObj?.session_length || 60,
        bookings: [],
        ...(finalPaymentMethodId
          ? { payment_method_id: finalPaymentMethodId }
          : {}),
        ...(acPaymentType === 'insurance' || acPaymentType === 'copay'
          ? (() => {
              const savedIns = acInsurances.find(
                ins => ins._id === acSelectedInsuranceId
              )
              return {
                insurance_card_id: acSelectedInsuranceId || null,
                payer_id: acSelectedInsuranceId
                  ? savedIns?.payer_id || savedIns?.payerId || null
                  : resolvedAcPayerId || null,
                insuranceName: acSelectedInsuranceId
                  ? savedIns?.insuranceName ||
                    savedIns?.payer_name ||
                    savedIns?.name ||
                    null
                  : acNewInsuranceName || null,
                policyNumber: acSelectedInsuranceId
                  ? savedIns?.policyNumber || savedIns?.policy_number || null
                  : acPolicyId || null,
                policy_id: acSelectedInsuranceId
                  ? savedIns?.policyNumber || savedIns?.policy_number || null
                  : acPolicyId || null,
              }
            })()
          : {}),
      }

      const res = await api.post('/contracts/create-contract-agency', payload)

      const newContractId =
        res?.data?.contract?._id || res?.data?.data?._id || res?.data?._id || ''

      showAcMessage(
        res?.data?.message || 'Contract created successfully!',
        'success'
      )
      setOpenAddContractDialog(false)
      if (newContractId) {
        console.log('DEBUG opening DocuSign dialog for ID:', newContractId)
        setSignContractId(newContractId)
        setOpenSignContractDialog(true)
      } else {
        console.error(
          'DEBUG cannot open DocuSign dialog: newContractId is empty!'
        )
      }
    } catch (err: any) {
      showAcMessage(
        err?.response?.data?.message || 'Failed to create contract.',
        'error'
      )
    } finally {
      setAcSubmitting(false)
    }
  }

  // Specialization Search States
  const [specializationSearchTerm, setSpecializationSearchTerm] = useState('')

  const [specializationOptions, setSpecializationOptions] = useState<any[]>([])

  const [specializationLoading, setSpecializationLoading] = useState(false)

  const [showSpecializationDropdown, setShowSpecializationDropdown] =
    useState(false)

  const [isSelectingSpecialization, setIsSelectingSpecialization] =
    useState(false)

  const specializationDropdownRef = useRef<any>(null)

  const [location, setLocation] = useState<string | null>('')

  const [locationPredictions, setLocationPredictions] = useState<any[]>([])

  const [locationSearchTerm, setLocationSearchTerm] = useState('')

  const [locationLoading, setLocationLoading] = useState(false)
  const [selectedLocationData, setSelectedLocationData] = useState<any>(null)
  const [therapistIdPackage, setTherapistIdPackage] = useState<any>([])

  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<PaymentMethod | null>(null)
  const fecthTherapistPackage = async (therapistId: string) => {
    try {
      const response = await api.get(
        `/services/agency-therapist-package?therapist_id=${therapistId}`
      )
      setTherapistIdPackage(response?.data)
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to fetch therapist packages'
      )
    }
  }

  useEffect(() => {
    const rawTherapist = agencySelectedPatient?.therapistId
    const therapistId =
      typeof rawTherapist === 'string' ? rawTherapist : rawTherapist?._id
    if (therapistId) {
      fecthTherapistPackage(therapistId)
    }
  }, [agencySelectedPatient])

  const navigate = useNavigate()
  const handlePatientAdd = async () => {
    try {
      const response = await api.post(
        '/agency-patient/patient-signup',
        fromDataPatienSignupData
      )
      toast.success(response?.data?.message || 'Patient added successfully')
      setFromDataPatienSignupData({})
      // Refresh active patients or all patients list depending on current view
      if (activeTab === 'active') {
        fetchTherapists(currentPage, true)
      } else if (activeTab === 'all') {
        fetchTherapists(currentPage)
      } else if (activeTab === 'unassigned') {
        fetchTherapists(currentPage, false, true)
      } else {
        fetchTherapists(currentPage)
      }
      return true
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to add patient'
      )
      return false
    }
  }

  const [fromDataPatienSignupData, setFromDataPatienSignupData] = useState({})
  const {
    isLoaded: isPlacesLoaded,
    isLoading: isPlacesLoading,
    autocompleteService,
  } = useGooglePlaces()

  useEffect(() => {
    if (
      !autocompleteService ||
      !locationSearchTerm ||
      !locationSearchTerm.trim()
    ) {
      setLocationPredictions([])
      return
    }

    setLocationLoading(true)

    autocompleteService.getPlacePredictions(
      {
        input: locationSearchTerm,
        types: ['geocode'],
      },
      (predictions, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          setLocationPredictions(predictions)
        } else {
          setLocationPredictions([])
        }

        setLocationLoading(false)
      }
    )
  }, [autocompleteService, locationSearchTerm])
  const handleLocationInputChange = (value: string) => {
    setLocationSearchTerm(value)
  }

  // Fetch available slots when date changes in the Direct Session dialog
  useEffect(() => {
    if (!dsSelectedDate || !openDirectSessionDialog) {
      setDsSlots([])
      return
    }

    // Extract therapist ID — therapistId can be a populated object or a plain string
    const rawTherapist =
      agencySelectedPatient?.therapistId ||
      agencySelectedPatient?.assigned_therapist ||
      null
    const therapistId: string | null =
      typeof rawTherapist === 'string'
        ? rawTherapist
        : rawTherapist?._id
          ? String(rawTherapist._id)
          : null

    if (!therapistId) {
      setDsSlots([])
      return
    }

    const pad = (n: number) => String(n).padStart(2, '0')
    const formattedDate = `${dsSelectedDate.getFullYear()}-${pad(dsSelectedDate.getMonth() + 1)}-${pad(dsSelectedDate.getDate())}`

    ;(async () => {
      setDsLoadingSlots(true)
      try {
        const res = await api.get(
          `/therapist/schedule/available-slots?therapistId=${encodeURIComponent(therapistId)}&date=${formattedDate}`
        )
        const serverData = res?.data?.data ?? []
        const normalized: any[] = Array.isArray(serverData)
          ? serverData
              .map((s: any) => {
                if (!s) return null
                const start = s.startTime ?? s.start_time ?? s.start
                const end = s.endTime ?? s.end_time ?? s.end
                if (!start || !end) return null
                return { _id: s._id, startTime: start, endTime: end }
              })
              .filter(Boolean)
          : []
        setDsSlots(normalized)
      } catch (err) {
        console.error('Direct session slot fetch error:', err)
        setDsSlots([])
      } finally {
        setDsLoadingSlots(false)
      }
    })()
  }, [dsSelectedDate, openDirectSessionDialog, agencySelectedPatient])

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        specializationDropdownRef.current &&
        !specializationDropdownRef.current.contains(event.target)
      ) {
        setShowSpecializationDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const fetchSpecializationOptions = async (search: string) => {
    try {
      setSpecializationLoading(true)

      const response = await api.get('/specilities/specility', {
        params: { search },
      })

      const data = response?.data?.data || response?.data || []

      setSpecializationOptions(data)
    } catch (error) {
      console.error('Error fetching specialization:', error)

      setSpecializationOptions([])
    } finally {
      setSpecializationLoading(false)
    }
  }
  useEffect(() => {
    if (isSelectingSpecialization) return

    const handler = setTimeout(() => {
      fetchSpecializationOptions(specializationSearchTerm)
    }, 400)

    return () => clearTimeout(handler)
  }, [specializationSearchTerm, isSelectingSpecialization])

  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
    therapist: any
  ) => {
    setMenuAnchorEl(event.currentTarget)
    setSelectedTherapistForMenu(therapist)
    setAgencySelectedPatient(therapist)
  }

  const handleCloseMenu = () => {
    setMenuAnchorEl(null)
    setSelectedTherapistForMenu(null)
  }

  const handleOpenInsuranceDialog = async (patientId: string) => {
    if (!patientId) return
    handleCloseMenu()
    setOpenInsuranceDialog(true)
    setPatientInsurancesLoading(true)
    setSelectedInsuranceIndex(0)
    try {
      const response = await api.get(
        `/patient/insurance/patient-insurance/${patientId}`
      )
      const data = response?.data?.data || response?.data || []
      const insurancesList = Array.isArray(data) ? data : [data]
      setPatientInsurances(insurancesList)
    } catch (error: any) {
      console.error('Error fetching patient insurance details:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to fetch insurance details'
      )
      setPatientInsurances([])
    } finally {
      setPatientInsurancesLoading(false)
    }
  }

  const handleOpenApprovalReview = (approval: any) => {
    setSelectedApproval(approval)
    setOpenApprovalReview(true)
  }

  const handleCloseApprovalReview = () => {
    setOpenApprovalReview(false)
    setSelectedApproval(null)
  }
  const [commissionData, setCommissionData] = useState<any>(null)
  const [enrollmentStatus, setEnrollmentStatus] = useState<string>('')
  const [openTablePopup, setOpenTablePopup] = useState(false)
  const [tableData, setTableData] = useState<any>(null)
  const [tableTitle, setTableTitle] = useState<string>('')
  const [activeTab, setActiveTab] = useState<string>('all')

  // Invite Provider State
  const [openInviteDialog, setOpenInviteDialog] = useState(false)
  const [inviteName, setInviteName] = useState('')
  const [inviteEmail, setInviteEmail] = useState('')
  const [inviteLoading, setInviteLoading] = useState(false)
  const [openPatientAddDialog, setOpenPatientAddDialog] = useState(false)
  const handleOpenInviteDialog = () => {
    setInviteName('')
    setInviteEmail('')
    setOpenInviteDialog(true)
  }

  const handleCloseInviteDialog = () => {
    setOpenInviteDialog(false)
    setInviteName('')
    setInviteEmail('')
  }

  const handleInviteProvider = async () => {
    if (!inviteName.trim() || !inviteEmail.trim()) {
      toast.error('Please enter both name and email')
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(inviteEmail)) {
      toast.error('Please enter a valid email address')
      return
    }

    setInviteLoading(true)
    try {
      const response = await api.post('patient-invitations/invite', {
        patientName: inviteName.trim(),
        patientEmail: inviteEmail.trim(),
      })

      if (response.status === 200 || response.status === 201) {
        toast.success('Invitation sent successfully')
        handleCloseInviteDialog()
        fetchInvitations(1)
        if (activeTab === 'active') {
          fetchTherapists(currentPage, true)
        } else if (activeTab === 'unassigned') {
          fetchTherapists(currentPage, false, true)
        } else {
          fetchTherapists(currentPage)
        }
      }
    } catch (error: any) {
      console.error('Error inviting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to send invitation')
    } finally {
      setInviteLoading(false)
    }
  }

  const handleEnrollmentStatusChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setEnrollmentStatus(e.target.value)
  }
  //finalperclaimfee show only two decimal point
  const finalperclaimfee =
    Number(monthlyCommission) - Number(providerFeeDiscountPercent)
  const finalperclaimfeeDisplay = finalperclaimfee.toFixed(2)
  const handleExport = async () => {
    setExportLoading(true)
    try {
      const params: Record<string, any> = {
        accountStatus:
          selectedAccountStatus === 'Active'
            ? true
            : selectedAccountStatus === 'Inactive'
              ? false
              : undefined,
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      const response = await api.get('agency-patient/patients/export', {
        responseType: 'blob',
        params,
      })

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: String(response.headers['content-type'] || 'text/csv'),
      })

      // Create a download link
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      // Get filename from Content-Disposition header or use default
      // const contentDisposition = response.headers['content-disposition']
      let filename = 'patients_export.csv'
      // if (contentDisposition) {
      //   const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i)
      //   if (filenameMatch) {
      //     filename = filenameMatch[1]
      //   }
      // }

      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      toast.success('Export completed successfully')
    } catch (error) {
      console.error('Error exporting providers:', error)
      toast.error('Failed to export providers data')
    } finally {
      setExportLoading(false)
    }
  }

  const getCommonParams = (page?: number) => {
    const params: Record<string, any> = {
      page: page || 1,
      limit: pageSize,
    }

    if (selectedInsurance) {
      params.insurance = selectedInsurance
    }

    if (selectedSpecialization) {
      params.specialization = selectedSpecialization
    }

    if (selectedGender) {
      params.gender = selectedGender.toLowerCase()
    }

    if (location) {
      params.location = location
    }

    if (searchKeyword?.trim()) {
      params.search = searchKeyword
    }

    if (enrollmentStatus) {
      params.enrollmentStatus = enrollmentStatus
    }

    if (startDate) {
      params.startDate = getFormattedDateForAPI(startDate)
    }

    if (endDate) {
      params.endDate = getFormattedDateForAPI(endDate)
    }

    if (licenseExpiryDate) {
      params.expiry = getFormattedDateForAPI(licenseExpiryDate)
    }

    if (sortField) {
      params.sortField = sortField
      params.sortOrder = sortOrder
    }

    return params
  }

  const getFormattedDateForAPI = (date: Date | null): string | null => {
    if (!date) return null

    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return `${year}-${month}-${day}` // YYYY-MM-DD format
  }
  const handleAccountStatusChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAccountStatus(event.target.value)
  }

  const handleOpenToggle = (providerId: string, currentStatus: boolean) => {
    setSelectedTherapistId(providerId) // Set the selected therapist to toggle
    setIsActive(currentStatus) // Set the current status of the therapist (active or inactive)
    setOpenToggle(true) // Open the confirmation dialog
  }

  const handleConfirmToggle = async () => {
    if (!selectedTherapistId) return // Exit if no therapist is selected
    setLoading(true) // Start loading

    const newStatus = !isActive // Toggle the status
    try {
      const response = await api.patch(
        `/admin/therapist/${selectedTherapistId}/status`,
        { isActive: newStatus }
      )

      if (response.status === 200) {
        setIsActive(newStatus) // Toggle status locally
        toast.success(
          `Provider status updated to ${newStatus ? 'Active' : 'Inactive'}`
        )
      }

      setOpenToggle(false) // Close the dialog after success
      fetchTherapists() // Optionally refresh the therapist list
    } catch (error) {
      console.error('Error updating the provider status:', error)
      toast.error('Failed to update provider status')
    } finally {
      setLoading(false) // Stop loading
    }
  }

  const handleOpenDeleteDialog = (therapist: any) => {
    setSelectedProviderForDelete(therapist)
    setOpenDeleteDialog(true)
  }

  const handleCloseDeleteDialog = () => {
    if (!deleteLoading) {
      setOpenDeleteDialog(false)
      setSelectedProviderForDelete(null)
    }
  }

  const handleConfirmDelete = async () => {
    if (!selectedProviderForDelete?._id) return

    setDeleteLoading(true)
    try {
      await api.delete(`admin/provider/${selectedProviderForDelete._id}`)
      toast.success('Provider deleted successfully')
      handleCloseDeleteDialog()
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error deleting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to delete provider')
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleOpenCommissionDialog = (therapist: any) => {
    setSelectedTherapistId(therapist._id)
    setMonthlyCommission(therapist.commission?.toString() || '')
    setProviderFeeDiscountPercent(
      therapist.providerFeeDiscountPercent?.toString() || ''
    )
    setCommissionData(therapist)

    console.log('commissionData', therapist)
    setOpenCommissionDialog(true)
  }

  const handleCloseCommissionDialog = () => {
    setOpenCommissionDialog(false)
    setSelectedTherapistId(null)
    setMonthlyCommission('')
    setYearlyCommission('')
    setProviderFeeDiscountPercent('')
    setCommissionData(null)
  }

  const handleUpdateCommission = async () => {
    if (!selectedTherapistId) return

    // Validate inputs
    if (!monthlyCommission.trim()) {
      toast.error('Please enter both monthly and yearly commission values')
      return
    }
    if (finalperclaimfee <= 0) {
      toast.error(
        'The entered percentages result in a platform fee of 0 or less. Please update the values to maintain a minimum positive fee.'
      )
      return
    }

    const commission = parseFloat(monthlyCommission)
    const discountValue = providerFeeDiscountPercent.trim()
      ? parseFloat(providerFeeDiscountPercent)
      : 0

    if (isNaN(commission) || commission < 0) {
      toast.error('Please enter valid commission values (numbers >= 0)')
      return
    }

    if (
      providerFeeDiscountPercent.trim() &&
      (isNaN(discountValue) || discountValue < 0 || discountValue > 100)
    ) {
      toast.error('Please enter a valid discount percentage (0-100)')
      return
    }

    setCommissionLoading(true)
    try {
      const response = await api.patch(
        `/admin/therapist/${selectedTherapistId}/commission`,
        {
          commission: commission,
          providerFeeDiscountPercent: discountValue,
        }
      )

      if (response.status === 200) {
        toast.success('Commission updated successfully')
        handleCloseCommissionDialog()
      }
    } catch (error: any) {
      console.error('Error updating commission:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to update commission'
      )
    } finally {
      setCommissionLoading(false)
    }
  }

  const handleOpenVerificationDialog = (therapist: any) => {
    setSelectedProvider(therapist)
    setOpenVerificationDialog(true)
  }

  const handleCloseVerificationDialog = () => {
    setOpenVerificationDialog(false)
    setSelectedProvider(null)
  }

  const handleOpenProviderDetailsDialog = (therapist: any) => {
    setSelectedProviderForDetails(therapist)
    setOpenProviderDetailsDialog(true)
  }

  const handleCloseProviderDetailsDialog = () => {
    setOpenProviderDetailsDialog(false)
    setSelectedProviderForDetails(null)
  }

  const handleApproveTherapist = async () => {
    if (!selectedProvider?._id) return

    setApproveLoading(true)
    try {
      const response = await api.post(
        `/therapist/${selectedProvider._id}/approve`
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        handleCloseVerificationDialog()
        fetchTherapists() // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error approving provider:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to approve provider'
      )
    } finally {
      setApproveLoading(false)
    }
  }

  const handleOpenBlockReasonDialog = () => {
    setBlockReason('')
    setOpenBlockReasonDialog(true)
  }

  const handleCloseBlockReasonDialog = () => {
    setOpenBlockReasonDialog(false)
    setBlockReason('')
  }

  const handleConfirmBlock = async () => {
    if (!selectedProvider?._id) return

    if (!blockReason.trim()) {
      toast.error('Please provide a reason for blocking the provider')
      return
    }

    setBlockLoading(true)
    try {
      const response = await api.post(
        `/therapist/${selectedProvider._id}/block`,
        {
          reason: blockReason.trim(),
        }
      )

      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        handleCloseBlockReasonDialog()
        handleCloseVerificationDialog()
        fetchTherapists() // Refresh the therapist list
      }
    } catch (error: any) {
      console.error('Error blocking provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to block provider')
    } finally {
      setBlockLoading(false)
    }
  }

  const handleOpenReverifyDialog = (therapist: any) => {
    setReverifyProviderId(therapist?._id || null)
    setReverifyProviderName(
      therapist
        ? `${therapist?.firstName || ''} ${therapist?.lastName || ''}`.trim()
        : ''
    )
    setOpenReverifyDialog(true)
  }

  const handleCloseReverifyDialog = () => {
    setOpenReverifyDialog(false)
    setReverifyProviderId(null)
    setReverifyProviderName('')
  }

  const handleReverifyProvider = async () => {
    if (!reverifyProviderId) return

    setReverifyLoading(true)

    try {
      const response = await api.get(
        `/agreements/signed/therapist-verification/${reverifyProviderId}`
      )

      const message =
        response?.data?.message ||
        'patient re-verification request completed successfully'

      toast.success(message)

      // Refresh the therapist list to reflect any potential changes
      fetchTherapists(currentPage)
    } catch (error: any) {
      console.error('Error during provider re-verification:', error)

      const message =
        error?.response?.data?.message || 'Failed to re-verify provider'

      toast.error(message)
    } finally {
      setReverifyLoading(false)
      handleCloseReverifyDialog()
    }
  }

  const formatDateMMDDYY = (date: string | Date | null | undefined) => {
    if (!date) return '--'
    const dayjsDate = dayjs(date)
    if (!dayjsDate.isValid()) return '--'
    return dayjsDate.format('MM/DD/YYYY')
  }
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page)
    fetchTherapists(page)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    sessionStorage.setItem('prevSize', newPageSize.toString())
  }
  const fetchTherapists = async (
    page?: number,
    onlyActive?: boolean,
    unassigned?: boolean
  ) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params = getCommonParams(page)
      if (onlyActive) {
        params.accountStatus = true
      }

      if (unassigned) {
        params.unassign = true
      }
      if (selectedInsurance) {
        params.insurance = selectedInsurance
      }

      if (selectedSpecialization) {
        params.specialization = selectedSpecialization
      }

      if (selectedGender) {
        params.gender = selectedGender.toLowerCase()
      }
      if (location) {
        params.location = location
      }

      // If search keyword exists, add it to params
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }

      if (enrollmentStatus) {
        params.enrollmentStatus = enrollmentStatus
      }

      if (startDate) {
        params.startDate = getFormattedDateForAPI(startDate)
      }

      if (endDate) {
        params.endDate = getFormattedDateForAPI(endDate)
      }

      if (licenseExpiryDate) {
        params.expiry = getFormattedDateForAPI(licenseExpiryDate)
      }

      // Add sorting parameters
      if (sortField) {
        params.sortField = sortField
        params.sortOrder = sortOrder
      }

      // Make the API call with params
      console.log('Fetching therapists with params:', params)
      const response = await api.get('agency-patient/patients', {
        params,
      })
      console.log('API Response received:', response?.data)

      // Check if data exists and set the therapists state
      if (response?.data?.data) {
        setPatients(response.data.data)
      } else {
        setError('No providers data found')
      }
      setTotalRecords(response?.data?.stats?.totalPatients || 0)
      setTotalActiveRecords(response?.data?.stats?.totalActivePatients || 0)
      setUnassignRecords(response?.data?.stats?.patientUnassign || 0)
      setTotalInvitationRecords(response?.data?.stats?.patientInvitation || 0)
      setTotalPages(Math.ceil(response?.data?.totalRecords / pageSize) || 1)
    } catch (err: any) {
      console.error('Error fetching providers:', err?.response?.data || err)
      setError('Failed to fetch providers')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }

  // Location search effects removed in favor of direct state change query binding
  const fetchInvitations = async (page?: number) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params: Record<string, any> = {
        page: page || 1,
        limit: pageSize,
      }
      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }
      const response = await api.get('patient-invitations/agency', {
        params,
      })
      // API returns a plain array directly
      const list = Array.isArray(response?.data)
        ? response.data
        : response?.data?.data || []
      setInvitationsList(list)
      const total = Array.isArray(response?.data)
        ? response.data.length
        : response?.data?.totalRecords || 0
      setTotalInvitations(total)
      if (activeTab === 'invitations') {
        setTotalPages(Math.ceil(total / pageSize) || 1)
      }
    } catch (err: any) {
      console.error('Error fetching invitations:', err)
      setError('Failed to fetch invitations')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }

  const fetchPendingApprovals = async () => {
    setPendingApprovalsLoading(true)
    try {
      const params = getCommonParams(currentPage)

      const response = await api.get('agency/provider-approvals/pending', {
        params,
      })
      const list = response?.data?.data || []
      setPendingApprovalsList(list)
    } catch (err: any) {
      console.error('Error fetching pending approvals:', err)
    } finally {
      setPendingApprovalsLoading(false)
    }
  }

  const handleApproveProvider = async (approvalId: string) => {
    try {
      const response = await api.patch(
        `agency/provider-approvals/${approvalId}/approve`
      )
      if (response.status === 200 || response.status === 201) {
        toast.success(
          response?.data?.message || 'Provider approved successfully'
        )
        fetchPendingApprovals()
      }
    } catch (error: any) {
      console.error('Error approving provider:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to approve provider'
      )
    }
  }

  const handleRejectProvider = async (approvalId: string) => {
    try {
      const response = await api.patch(
        `agency/provider-approvals/${approvalId}/reject`
      )
      if (response.status === 200 || response.status === 201) {
        toast.success(
          response?.data?.message || 'Provider rejected successfully'
        )
        fetchPendingApprovals()
      }
    } catch (error: any) {
      console.error('Error rejecting provider:', error)
      toast.error(error?.response?.data?.message || 'Failed to reject provider')
    }
  }

  const handleReset = () => {
    setSearchKeyword('')
    setSelectedAccountStatus('')
    setStartDate(null)
    setEndDate(null)
    setLicenseExpiryDate(null)
    setSortField('')
    setSortOrder('asc')
    setEnrollmentStatus('')
    setLocation('')
    setSelectedLocationData(null)
    setInsuranceSearchTerm('')
    setSelectedInsurance('')
    setSpecializationSearchTerm('')
    setSelectedSpecialization('')
    setSelectedGender('')
    setCurrentPage(1)
  }

  const handleSort = (field: string) => {
    if (sortField === field) {
      // Toggle sort order if same field
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      // Set new field and default to ascending
      setSortField(field)
      setSortOrder('asc')
    }
  }

  const getSortIcon = (field: string) => {
    if (sortField !== field) {
      return <UnfoldMoreIcon className="w-4 h-4 ml-1" />
    }
    return sortOrder === 'asc' ? (
      <KeyboardArrowUpIcon className="w-4 h-4 ml-1" />
    ) : (
      <KeyboardArrowDownIcon className="w-4 h-4 ml-1" />
    )
  }

  useEffect(() => {
    // Initial fetch to get the count for the cards
    fetchInvitations(1)
    fetchPendingApprovals()
  }, [])

  useEffect(() => {
    if (activeTab === 'invitations') {
      fetchInvitations(currentPage)
    }

    // else if (activeTab === 'pending') {
    //   fetchPendingApprovals()
    // }
    else if (activeTab === 'active') {
      fetchTherapists(currentPage, true)
    } else if (activeTab === 'unassigned') {
      fetchTherapists(currentPage, false, true)
    } else {
      fetchTherapists(currentPage)
    }
  }, [
    searchKeyword,
    selectedAccountStatus,
    startDate,
    endDate,
    licenseExpiryDate,
    sortField,
    sortOrder,
    pageSize,
    currentPage,
    enrollmentStatus,
    activeTab,
    selectedInsurance,
    selectedSpecialization,
    selectedGender,
    location,
  ])

  const handlePatientAddOpenDialog = () => {
    setOpenPatientAddDialog(true)
  }

  const handleViewProfile = (patient: any) => {
    if (!patient) return
    setSelectedPatientProfile(patient)
    setOpenPatientProfileDialog(true)
    handleCloseMenu()
  }

  const handleClosePatientProfile = () => {
    setOpenPatientProfileDialog(false)
    setSelectedPatientProfile(null)
  }

  const handleRemoveAgency = async (patientId: string) => {
    if (!patientId) return
    try {
      const response = await api.delete(`/agency-patient/${patientId}/remove`)
      toast.success(
        response?.data?.message || 'Patient removed from agency successfully'
      )
      // Refresh active patients or all patients list depending on current view
      if (activeTab === 'active') {
        fetchTherapists(currentPage, true)
      } else if (activeTab === 'all') {
        fetchTherapists(currentPage)
      } else if (activeTab === 'unassigned') {
        fetchTherapists(currentPage, false, true)
      } else {
        fetchTherapists(currentPage)
      }
    } catch (error: any) {
      console.error('Error removing patient from agency:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to remove patient from agency'
      )
    }
  }

  const handleRemoveInvitation = async (patientId: string) => {
    if (!patientId) return
    try {
      const response = await api.patch(
        `/patient-invitations/${patientId}/revoke`
      )
      toast.success(
        response?.data?.message || 'Invitation revoked successfully'
      )

      if (activeTab === 'invitations') {
        fetchInvitations(currentPage)
      }
    } catch (error: any) {
      console.error('Error removing invitation:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to remove invitation'
      )
    }
  }

  const handleOpenPatientStatusDialog = (patient: any) => {
    if (!patient?._id) return
    setPatientStatusTarget(patient)
    setPatientStatusCurrent(isPatientActive(patient))
    setOpenPatientStatusDialog(true)
    handleCloseMenu()
  }

  const handleConfirmPatientStatus = async () => {
    if (!patientStatusTarget?._id) return
    setPatientStatusLoading(true)

    const newStatus = !patientStatusCurrent
    try {
      const response = await api.patch(
        `/agency-patient/patient/${patientStatusTarget._id}/status`,
        { isActive: newStatus }
      )

      toast.success(
        response?.data?.message ||
          `Patient ${newStatus ? 'enabled' : 'disabled'} successfully`
      )

      // Optimistically update local state so the menu/dialog reflect the new status immediately
      const newPatientStatus = newStatus ? 'active' : 'inactive'
      setPatients((prev: any[]) =>
        prev.map(p =>
          p._id === patientStatusTarget._id
            ? { ...p, status: newPatientStatus }
            : p
        )
      )
      setAgencySelectedPatient((prev: any) =>
        prev && prev._id === patientStatusTarget._id
          ? { ...prev, status: newPatientStatus }
          : prev
      )
      setPatientStatusCurrent(newStatus)

      if (activeTab === 'active') {
        fetchTherapists(currentPage, true)
      } else if (activeTab === 'all') {
        fetchTherapists(currentPage)
      } else if (activeTab === 'unassigned') {
        fetchTherapists(currentPage, false, true)
      } else {
        fetchTherapists(currentPage)
      }
      setOpenPatientStatusDialog(false)
      setPatientStatusTarget(null)
    } catch (error: any) {
      console.error('Error updating patient status:', error)
      toast.error(
        error?.response?.data?.message || 'Failed to update patient status'
      )
    } finally {
      setPatientStatusLoading(false)
    }
  }

  const fetchAgencyProviders = async (patientId: string) => {
    setAssignProviderLoading(true)
    try {
      const response = await api.get(
        `/agency-patient/top-providers/${patientId}`
      )
      const raw: Record<string, unknown>[] =
        (response?.data?.results as Record<string, unknown>[]) || []
      const providers = raw
        .filter(item => item.therapist_id)
        .map(item => ({
          ...(item.therapist_id as Record<string, unknown>),
          score: item.score,
          services: item.services,
          per_session: item.per_session,
        }))
      setAllAgencyProviders(providers)
    } catch {
      setAllAgencyProviders([])
    } finally {
      setAssignProviderLoading(false)
    }
  }

  const handleOpenAssignProvider = () => {
    setAllAgencyProviders([])
    setAssignProviderSelected(null)
    setOpenAssignProviderDialog(true)
    handleCloseMenu()
    if (agencySelectedPatient?._id) {
      fetchAgencyProviders(agencySelectedPatient._id)
    }
  }

  const handleCloseAssignProvider = () => {
    setOpenAssignProviderDialog(false)
    setAllAgencyProviders([])
    setAssignProviderSelected(null)
  }

  const handleAssignProvider = async (prov: Record<string, unknown>) => {
    if (!prov?._id || !agencySelectedPatient?._id) return
    setAssignProviderSelected(prov)
    setAssignProviderSubmitting(true)
    try {
      const response = await api.post('/contracts/assign-provider', {
        patientId: agencySelectedPatient._id,
        therapistId: prov._id,
      })
      toast.success(response?.data?.message || 'Provider assigned successfully')
      handleCloseAssignProvider()
      if (activeTab === 'active') fetchTherapists(currentPage, true)
      else if (activeTab === 'unassigned')
        fetchTherapists(currentPage, false, true)
      else fetchTherapists(currentPage)
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Failed to assign provider')
    } finally {
      setAssignProviderSubmitting(false)
      setAssignProviderSelected(null)
    }
  }

  console.log(
    'selectedPatientProfile',
    selectedPatientProfile
  )

  return (
    <div className="p-6 mx-auto max-w-7xl">
      {/* Header & Filters */}
      {/* Header */}
      <div className="flex flex-col items-start justify-between gap-4 mb-4 sm:flex-row sm:items-center">
        <div className="flex flex-col items-start gap-1">
          <h1 className="text-2xl font-bold text-[#4B3E7C]">Patients</h1>
          <span className="text-sm font-medium text-gray-500">
            Manage, review, assign, and monitor all onboarded patients across
            the agency.
          </span>
        </div>

        <div className="flex items-center gap-3">
          <button
            className="flex items-center gap-2 px-4 py-2 text-[#4B3E7C] bg-white border border-[#A0AEC0] rounded-lg hover:bg-gray-50 disabled:opacity-50 text-sm font-medium"
            onClick={handleExport}
            disabled={exportLoading}
            style={{
              cursor: exportLoading ? 'not-allowed' : 'pointer',
            }}
          >
            <FiDownload className="w-4 h-4" />
            {exportLoading ? 'Exporting...' : 'Export CSV'}
          </button>
          {hasPermission('patient.create') && (
            <button
              className="flex items-center gap-2 px-4 py-2 text-white bg-[#7A6FA1] border border-transparent rounded-lg hover:bg-[#6c6191] disabled:opacity-50 text-sm font-medium shadow-sm"
              disabled={exportLoading}
              style={{ cursor: 'pointer' }}
              onClick={handleOpenInviteDialog}
            >
              <Plus className="w-4 h-4" />
              Invite Patient
            </button>
          )}
          {hasPermission('patient.create') && (
            <button
              className="flex items-center gap-2 px-4 py-2 text-white bg-[#7A6FA1] border border-transparent rounded-lg hover:bg-[#6c6191] disabled:opacity-50 text-sm font-medium shadow-sm"
              style={{ cursor: 'pointer' }}
              onClick={handlePatientAddOpenDialog}
            >
              <Plus className="w-4 h-4" />
              Add Patient
            </button>
          )}
        </div>
      </div>

      {/* Provider Tabs as Cards */}
      <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-5">
        {[
          { key: 'all', label: 'Total Patients', count: totalRecords },
          { key: 'active', label: 'Active ', count: totalActiveRecords },
          { key: 'unassigned', label: 'Unassigned', count: unassignRecords },
          // { key: 'onleave', label: 'On Leave', count: onLeaveRecords },
          {
            key: 'invitations',
            label: 'Patient invitations',
            count: totalInvitationRecords,
          },
        ].map(tab => (
          <div
            key={tab.key}
            onClick={() => {
              setActiveTab(tab.key)
              setCurrentPage(1)
            }}
            className={`flex flex-col justify-between p-4 bg-white rounded-xl cursor-pointer transition-all duration-200 ${
              activeTab === tab.key
                ? 'border-[3px] border-[#7A6FA1] shadow-sm'
                : 'border border-gray-100 shadow-sm hover:border-gray-200 hover:shadow-md'
            }`}
          >
            <div className="flex justify-between items-start">
              <h2
                className={`text-[28px] leading-none font-bold ${activeTab === tab.key ? 'text-[#4B3E7C]' : 'text-[#7A6FA1]'}`}
              >
                {tab.count}
              </h2>
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#f3f0ff]">
                <PersonIcon sx={{ fontSize: 16, color: '#7A6FA1' }} />
              </div>
            </div>
            <p
              className={`text-[13px] font-medium mt-3 ${activeTab === tab.key ? 'text-gray-800' : 'text-gray-500'}`}
            >
              {tab.label}
            </p>
          </div>
        ))}
      </div>

      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="w-full md:w-[280px]">
          <label className="block mb-2 text-[13px] font-medium text-[#7A6FA1]">
            Search Patient
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <SearchIcon sx={{ fontSize: 18, color: '#A0AEC0' }} />
            </div>
            <input
              type="text"
              placeholder="Search patients by name,"
              value={searchKeyword}
              onChange={e => setSearchKeyword(e.target.value)}
              className="w-full pl-10 pr-3 py-[11px] bg-gray-50/50 border border-gray-200 rounded-xl text-[13px] focus:outline-none focus:ring-2 focus:ring-[#7A6FA1] focus:border-transparent"
            />
          </div>
        </div>

        {activeTab === 'invitations' ? null : (
          <div className="flex-1">
            <label className="block mb-2 text-[13px] font-medium text-[#7A6FA1]">
              Filters
            </label>
            <div className="flex items-center w-full bg-white border border-gray-200 rounded-xl px-1 py-1 h-[44px]">
              <div className="flex items-center flex-1 px-3 border-r border-gray-200 h-full">
                <LocationOn
                  sx={{
                    color: '#7A6FA1',
                    fontSize: 16,
                  }}
                  className="mr-2"
                />
                <div className="w-full relative">
                  <input
                    type="text"
                    value={location || ''}
                    onChange={e => {
                      setLocation(e.target.value)
                    }}
                    placeholder="Search location.."
                    className="w-full text-[13px] text-gray-500 bg-transparent focus:outline-none font-medium"
                    autoComplete="off"
                  />
                  {location && (
                    <button
                      type="button"
                      className="absolute right-2 top-0.5 text-xs text-gray-400 hover:text-gray-600"
                      onClick={() => {
                        setLocation('')
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>

              <div className="flex items-center flex-1 px-3 border-r border-gray-200 h-full">
                <HealthAndSafetyIcon
                  sx={{ fontSize: 16, color: '#7A6FA1' }}
                  className="mr-2"
                />
                <div className="w-full relative">
                  <input
                    type="text"
                    value={insuranceSearchTerm}
                    onChange={e => {
                      // setInsuranceSearchTerm(e.target.value)
                      // setSelectedInsurance('')
                      setInsuranceSearchTerm(e.target.value)
                      setSelectedInsurance('')
                      setShowInsuranceDropdown(true)
                    }}
                    onFocus={e => {
                      if (insuranceOptions.length > 0)
                        setShowInsuranceDropdown(true)
                    }}
                    // onBlur={e => {
                    //   setTimeout(() => setShowInsuranceDropdown(false), 150)
                    // }}
                    placeholder="Search Insurance.."
                    className="w-full text-[13px] text-gray-500 bg-transparent focus:outline-none font-medium"
                    autoComplete="off"
                  />
                  {insuranceLoading && (
                    <span className="absolute right-2 top-2 text-xs text-gray-400">
                      Loading...
                    </span>
                  )}
                  {(showInsuranceDropdown ||
                    (insuranceSearchTerm && insuranceOptions.length > 0)) && (
                    <ul className="absolute z-10 left-0 right-0 bg-white border border-gray-200 rounded shadow mt-1 max-h-40 overflow-y-auto">
                      {insuranceOptions.length === 0 ? (
                        <li className="px-3 py-2 text-[13px] text-gray-400">
                          No results found
                        </li>
                      ) : (
                        insuranceOptions.map((option: any) => (
                          <li
                            key={option._id}
                            className="px-3 py-2 text-[13px] text-gray-700 hover:bg-[#f3f0ff] cursor-pointer"
                            onMouseDown={() => {
                              setSelectedInsurance(option._id)
                              setInsuranceSearchTerm(option.payer_name)
                              setInsuranceOptions([])
                              setShowInsuranceDropdown(false)
                            }}
                          >
                            {option?.payer_name}
                          </li>
                        ))
                      )}
                    </ul>
                  )}
                  {insuranceSearchTerm && (
                    <button
                      type="button"
                      className="absolute right-6 top-2 text-xs text-gray-400 hover:text-gray-600"
                      onClick={() => {
                        setInsuranceSearchTerm('')
                        setSelectedInsurance('')
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>

              <div
                ref={specializationDropdownRef}
                className="relative flex items-center flex-1 px-3 border-r border-gray-200 h-full"
              >
                <PsychologyIcon
                  sx={{ fontSize: 16, color: '#7A6FA1' }}
                  className="mr-2"
                />

                <input
                  type="text"
                  placeholder="Select Specialization.."
                  value={specializationSearchTerm}
                  onChange={e => {
                    setSpecializationSearchTerm(e.target.value)
                    setShowSpecializationDropdown(true)
                  }}
                  onFocus={() => {
                    if (!showSpecializationDropdown) {
                      setShowSpecializationDropdown(true)

                      if (specializationOptions.length === 0) {
                        fetchSpecializationOptions('')
                      }
                    }
                  }}
                  className="w-full text-[13px] text-gray-500 bg-transparent focus:outline-none placeholder-gray-400"
                />
                <div className="absolute right-2 flex items-center gap-2">
                  {specializationLoading && (
                    <span className="text-[11px] text-[#7A6FA1]">
                      Loading...
                    </span>
                  )}

                  {specializationSearchTerm && (
                    <button
                      type="button"
                      onClick={() => {
                        setIsSelectingSpecialization(true)

                        setSpecializationSearchTerm('')
                        setSelectedSpecialization('')
                        setShowSpecializationDropdown(false)

                        setTimeout(() => {
                          setIsSelectingSpecialization(false)
                        }, 200)
                      }}
                      className="flex items-center justify-center w-5 h-5 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-600 transition-all"
                    >
                      ×
                    </button>
                  )}
                </div>

                {showSpecializationDropdown && (
                  <div className="absolute left-0 right-0 top-[48px] z-50 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden">
                    <div className="max-h-[220px] overflow-y-auto">
                      {specializationOptions.length > 0 ? (
                        specializationOptions.map((item: any) => (
                          <div
                            key={item._id}
                            onMouseDown={() => {
                              setIsSelectingSpecialization(true)

                              setSelectedSpecialization(item._id)

                              setSpecializationSearchTerm(
                                item.name || item.label || ''
                              )

                              setShowSpecializationDropdown(false)

                              setTimeout(() => {
                                setIsSelectingSpecialization(false)
                              }, 200)
                            }}
                            className="px-4 py-3 text-[13px] text-gray-700 cursor-pointer hover:bg-[#f3f0ff] border-b border-gray-100 last:border-b-0 transition-all duration-150"
                          >
                            {item.name}
                          </div>
                        ))
                      ) : (
                        <div className="px-4 py-3 text-[13px] text-gray-400">
                          No specialization found
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="flex items-center flex-1 px-3 border-r border-gray-200 h-full">
              <TranslateIcon sx={{ fontSize: 16, color: '#7A6FA1' }} className="mr-2" />
              <select className="w-full text-[13px] text-gray-400 bg-transparent focus:outline-none appearance-none cursor-pointer">
                <option>Select Language</option>
              </select>
              <KeyboardArrowDownIcon sx={{ fontSize: 16, color: '#A0AEC0' }} />
            </div> */}
              <div className="relative flex items-center flex-1 px-3 h-full">
                <PersonOutlineIcon
                  sx={{ fontSize: 16, color: '#7A6FA1' }}
                  className="mr-2"
                />

                <Select
                  value={selectedGender}
                  onChange={e => setSelectedGender(e.target.value as string)}
                  displayEmpty
                  variant="standard"
                  disableUnderline
                  IconComponent={() => null}
                  sx={{
                    width: '100%',
                    fontSize: '13px',
                    color: selectedGender ? '#1E1743' : '#8A82A5',
                    fontWeight: 500,
                    cursor: 'pointer',
                    '& .MuiSelect-select': {
                      py: 0,
                      pr: '24px',
                      backgroundColor: 'transparent',
                      '&:focus': {
                        backgroundColor: 'transparent',
                      },
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(122, 111, 161, 0.15)',
                        border: '1px solid #e8e4f3',
                        mt: 1.5,
                        '& .MuiMenuItem-root': {
                          fontSize: '13px',
                          color: '#1E1743',
                          fontWeight: 500,
                          py: 1.2,
                          px: 2,
                          '&:hover': {
                            backgroundColor: '#f3f0ff',
                            color: '#7A6FA1',
                          },
                          '&.Mui-selected': {
                            backgroundColor: '#ede9f8',
                            color: '#4B3E7C',
                            fontWeight: 600,
                            '&:hover': {
                              backgroundColor: '#e6e1f6',
                            },
                          },
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: '#8A82A5' }}>Select Gender</span>
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                  <MenuItem value="Prefer not to say">Prefer not to say</MenuItem>
                </Select>

                <div className="absolute right-2 flex items-center gap-1 pointer-events-none">
                  {selectedGender && (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedGender('');
                      }}
                      className="flex items-center justify-center w-5 h-5 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-600 transition-all pointer-events-auto"
                    >
                      ×
                    </button>
                  )}

                  <KeyboardArrowDownIcon
                    sx={{ fontSize: 16, color: '#A0AEC0' }}
                  />
                </div>
              </div>
              <button
                type="button"
                onClick={handleReset}
                className="flex items-center justify-center px-3 py-1.5 text-[12px] font-semibold text-[#7A6FA1] bg-[#f3f0ff] hover:bg-[#e9e4fc] rounded-lg transition-colors flex-shrink-0 mr-1 ml-1"
              >
                Reset
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Therapist / Invitations / Pending Approvals Panel */}
      <div className="overflow-hidden bg-white rounded-2xl border border-[#E8E6F0] shadow-sm">
        <div className="px-6 py-5 border-b border-gray-100">
          <h2 className="text-xl font-bold text-[#4B3E7C]">
            {activeTab === 'invitations'
              ? 'All Invitations'
              : activeTab === 'unassigned'
                ? 'Unassigned Patients'
                : 'All Patients'}
          </h2>
          <p className="text-[13px] font-medium text-gray-500 mt-0.5">
            {activeTab === 'invitations' ? (
              <>
                <span className="font-semibold text-gray-700">
                  {
                    invitationsList.filter((i: any) => i.status === 'pending')
                      .length
                  }
                </span>{' '}
                Invitation sent &nbsp;·&nbsp;
                <span className="font-semibold text-[#10b981]">
                  {
                    invitationsList.filter((i: any) => i.status === 'accepted')
                      .length
                  }
                </span>{' '}
                Request Received
              </>
            ) : activeTab === 'unassigned' ? (
              `Providers who have requested to join your agency and are awaiting review.`
            ) : (
              `Showing ${totalActiveRecords} patients · 3 alerts require attention`
            )}
          </p>
        </div>
        <div className={activeTab === 'invitations' ? '' : 'overflow-x-auto'}>
          {activeTab === 'invitations' ? (
            <div>
              {loadingForShimmer ? (
                <div className="p-6">
                  <TableShimmer columns={4} />
                </div>
              ) : invitationsList?.length === 0 ? (
                <div className="p-8 text-center">
                  <Notfound />
                </div>
              ) : (
                invitationsList.map((invitation: any) => {
                  const isAccepted = invitation.status === 'accepted'
                  const patient = invitation.patientId
                  const displayName = patient
                    ? `${patient?.firstName || ''} ${patient?.lastName || ''}`.trim()
                    : invitation?.patientName
                  const email = patient?.email || invitation.patientEmail
                  const phone = patient?.phone || ''
                  const photo = patient?.profilePhotoUrl || ''
                  const isActive = isPatientActive(patient)
                  const dateLabel = isAccepted
                    ? `Received on ${formatDateMMDDYY(invitation.acceptedAt)}`
                    : `Invited on ${formatDateMMDDYY(invitation.createdAt)}`
                  const initials = displayName
                    .split(' ')
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((n: string) => n[0])
                    .join('')
                    .toUpperCase()
                  return (
                    <div
                      key={invitation._id}
                      className="flex items-center justify-between px-8 py-8 border-b border-gray-100 hover:bg-gray-50/60 transition-colors group"
                    >
                      {/* Left: Avatar + Info */}
                      <div className="flex items-center gap-4">
                        <div className="relative flex-shrink-0">
                          {photo ? (
                            <img
                              src={photo}
                              alt={displayName}
                              className="w-12 h-12 rounded-full object-cover border-2 border-white shadow"
                            />
                          ) : (
                            <div className="w-12 h-12 rounded-full bg-[#e9e4fc] flex items-center justify-center text-[#7A6FA1] font-bold text-sm border-2 border-white shadow">
                              {initials || (
                                <PersonIcon
                                  sx={{ fontSize: 22, color: '#7A6FA1' }}
                                />
                              )}
                            </div>
                          )}
                          {isActive && (
                            <span className="absolute bottom-0 right-0 w-4 h-4 bg-green-500 border-2 border-white rounded-full" />
                          )}
                        </div>
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <span className="font-bold text-[#4B3E7C] text-[15px]">
                              {displayName}
                            </span>
                            {/* <span className="px-1.5 py-0.5 text-[9px] font-bold text-[#7A6FA1] bg-[#e9e4fc] rounded uppercase tracking-wide">
                                {invitation?.specialization?.name}
                              </span> */}
                            <span
                              className={`px-1.5 py-0.5 text-[9px] font-bold rounded uppercase tracking-wide ${
                                invitation.status === 'accepted'
                                  ? 'text-[#2F855A] bg-[#E6F7EE]'
                                  : invitation.status === 'pending'
                                    ? 'text-[#B7791F] bg-[#FEF3C7]'
                                    : invitation.status === 'revoked'
                                      ? 'text-[#C53030] bg-[#FEE2E2]'
                                      : 'text-[#7A6FA1] bg-[#E9E4FC]'
                              }`}
                            >
                              {invitation.status}
                            </span>
                          </div>
                          <div className="flex items-center gap-4 text-[12px] text-gray-500">
                            {email && (
                              <span className="flex items-center gap-1">
                                <MailOutlineIcon sx={{ fontSize: 13 }} />
                                {email}
                              </span>
                            )}
                            {phone && (
                              <span className="flex items-center gap-1">
                                <PhoneOutlinedIcon sx={{ fontSize: 13 }} />
                                {phone}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Right: Status + Actions */}
                      <div className="flex items-center gap-3">
                        <div className="text-right">
                          {isAccepted ? (
                            <div className="flex items-center gap-1.5 justify-end">
                              <CheckCircleIcon
                                sx={{ fontSize: 16, color: '#10b981' }}
                              />
                              <span className="text-[13px] font-semibold text-[#10b981]">
                                Patient Request Received
                              </span>
                            </div>
                          ) : (
                            <div className="flex items-center gap-1.5 justify-end">
                              <MailOutlineIcon
                                sx={{ fontSize: 16, color: '#6b7280' }}
                              />
                              <span className="text-[13px] font-semibold text-gray-500">
                                Patient Invitation Sent
                              </span>
                            </div>
                          )}
                          <p className="text-[11px] text-gray-400 mt-0.5 text-right">
                            {dateLabel}
                          </p>
                        </div>
                        <IconButton
                          size="small"
                          onClick={e => handleOpenMenu(e, invitation)}
                          sx={{
                            color: '#9ca3af',
                            '&:hover': { color: '#4B3E7C' },
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  )
                })
              )}
            </div>
          ) : (
            <table className="min-w-full">
              <thead className="bg-[#e9e4fc]">
                <tr className="text-[10px] text-left text-[#7A6FA1] uppercase tracking-widest font-bold whitespace-nowrap">
                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('firstName')}
                  >
                    <div className="flex items-center">Patients</div>
                  </th>
                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('email')}
                  >
                    <div className="flex items-center">Preferences</div>
                  </th>
                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('phone')}
                  >
                    <div className="flex items-center">Location</div>
                  </th>

                  <th
                    className="px-6 py-3 font-medium cursor-pointer"
                    onClick={() => handleSort('gender')}
                  >
                    <div className="flex items-center">Gender / Language</div>
                  </th>
                  {/* <th
                      className="px-6 py-3 font-medium cursor-pointer"
                      onClick={() => handleSort('createdAt')}
                    >
                      <div className="flex items-center">Provider</div>
                    </th> */}
                  {/* <th className="px-6 py-3 font-medium">Payment Methods</th> */}
                  <th className="px-6 py-3 font-medium">
                    Total Session Count{' '}
                  </th>
                  <th className="px-6 py-3 font-medium">Next Visit</th>
                  <th className="px-6 py-3 font-medium">Action</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200">
                {loadingForShimmer ? (
                  <TableShimmer columns={11} />
                ) : patients?.length === 0 ? (
                  <tr>
                    <td colSpan={20} className="p-4 text-center">
                      <Notfound />
                    </td>
                  </tr>
                ) : (
                  patients.map(patient => (
                    <tr
                      key={patient._id}
                      className="border-b border-[#ECEAF3] hover:bg-[#FAFAFC] transition x whitespace-nowrap"
                    >
                      <td className="px-8 py-8 ">
                        <div className="flex items-center gap-5">
                          {/* Avatar */}
                          <div className="relative flex-shrink-0">
                            <Avatar
                              src={patient?.profilePhotoUrl}
                              alt={patient?.firstName}
                              sx={{
                                width: 70,
                                height: 70,
                                bgcolor: '#E5E7EB',
                                color: '#64748B',
                                borderRadius: '18px',
                              }}
                            />

                            {isPatientActive(patient) && (
                              <span className="absolute bottom-1 right-0 w-4 h-4 bg-[#39B273] border-[2px] border-white rounded-full"></span>
                            )}
                          </div>

                          {/* Info */}
                          <div>
                            {/* Name */}
                            <h3
                              className="text-[14px] font-bold text-[#59517D] leading-none cursor-pointer hover:underline "
                              onClick={() =>
                                handleOpenProviderDetailsDialog(patient)
                              }
                            >
                              {patient?.firstName} {patient?.lastName}
                            </h3>

                            <div className="flex flex-col gap-0.5 mt-2">
                              <div className="flex items-center gap-1.5 text-[12px] text-[#574F75]">
                                <MailOutlineIcon sx={{ fontSize: 14 }} />{' '}
                                {patient?.email || '--'}
                              </div>
                              <div className="flex items-center gap-1.5 text-[12px] text-[#574F75]">
                                <PhoneOutlinedIcon sx={{ fontSize: 14 }} />{' '}
                                {patient?.phone || '--'}
                              </div>
                            </div>

                            {/* Specialty */}
                            <div className="flex flex-wrap gap-2 mt-2">
                              {patient?.careNeeds?.map((item, index) => (
                                <div
                                  key={index}
                                  className="inline-flex max-w-[350px] bg-[#EDE9F8] rounded-sm px-2 py-1"
                                >
                                  <span className="text-[#6E67A5] text-[12px] break-words">
                                    {item}
                                  </span>
                                </div>
                              ))}
                            </div>

                            <div className="mt-2">
                              {isPatientActive(patient) ? (
                                <span className="inline-flex items-center px-3 py-1 rounded-sm bg-[#E6F7EE] text-[#2F855A] text-[10px] font-semibold">
                                  Active
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-3 py-1 rounded-sm bg-[#FEE2E2] text-[#C53030] text-[10px] font-semibold">
                                  Inactive
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* Start Days Time Freq <br /> Aug 10, 2025 Mon / Wed / Fri Morning <br /> (8AM–12PM) 3×
                              Weekly · 60 min (Static) */}

                      <td className="px-8 py-8">
                        <div className="flex flex-col gap-3">
                          <div className="text-[12px] text-[#574F75]">
                            {[
                              ...new Set(
                                patient?.jobs?.flatMap((job: any) =>
                                  (job?.preferredDays || []).map(
                                    (day: string) => {
                                      const dayMap: Record<string, string> = {
                                        Mon: 'Monday',
                                        Tue: 'Tuesday',
                                        Wed: 'Wednesday',
                                        Thu: 'Thursday',
                                        Fri: 'Friday',
                                        Sat: 'Saturday',
                                        Sun: 'Sunday',
                                      }

                                      return dayMap[day] || day
                                    }
                                  )
                                ) || []
                              ),
                            ].join(' / ') || '--'}
                          </div>
                          <div className="text-[12px] text-[#574F75]">
                            {[
                              ...new Set(
                                patient?.jobs?.flatMap(
                                  (job: any) => job?.preferredTimeWindows || []
                                ) || []
                              ),
                            ].join(' / ') || ''}
                          </div>
                          <div className="text-[12px] text-[#574F75]">
                            {[
                              ...new Set(
                                patient?.jobs
                                  ?.map((job: any) => job?.sessionLengthMinutes)
                                  ?.filter(
                                    (minutes: any) =>
                                      minutes !== undefined &&
                                      minutes !== null &&
                                      minutes !== ''
                                  )
                                  ?.map(
                                    (minutes: number) => `${minutes} mins`
                                  ) || []
                              ),
                            ].join(' / ') || ''}
                          </div>
                        </div>
                      </td>
                      <td className="px-8 py-8">
                        <div className="flex flex-col">
                          <span className="font-semibold text-[#4B3E7C] text-[12px]">
                            {patient?.addressLine1},{patient?.city},
                            {patient?.state},{patient?.postalCode}
                          </span>
                          {/* <span className="text-[12px] text-gray-500 mt-0.5">
                              {patient?.miles} miles away
                            </span> */}
                        </div>
                      </td>

                      <td className="px-8 py-8">
                        <div className="flex flex-col">
                          <span className="font-semibold text-[#4B3E7C] text-[12px]">
                            {patient?.gender
                              ? patient.gender.charAt(0).toUpperCase() +
                                patient.gender.slice(1).toLowerCase()
                              : '--'}
                          </span>

                          <div className="flex gap-1 mt-1 ">
                            <div className="flex flex-wrap gap-2 w-[420px]">
                              {(() => {
                                const langs = [
                                  ...new Set(
                                    patient?.jobs?.flatMap(
                                      (job: any) => job?.languages || []
                                    ) || []
                                  ),
                                ]

                                if (!langs || langs.length === 0) {
                                  return (
                                    <span className="px-2 ">
                                      {/* No Languages */}
                                    </span>
                                  )
                                }

                                return langs.map((lang: any, idx: number) => (
                                  <span
                                    key={idx}
                                    className="px-2 py-1 text-[12px] text-[#7A6FA1] bg-[#f3f0ff] rounded break-words"
                                  >
                                    {lang}
                                  </span>
                                ))
                              })()}
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* <td className="px-6 py-6 whitespace-nowrap">
                          {patient?.therapistId &&
                          typeof patient.therapistId === 'object' ? (
                            <div className="px-3 py-1">
                              <div className="flex items-center gap-3 bg-[#F7F8FC] border border-[#E8EAF2] rounded-[16px] px-4 py-2 w-[180px]">
                                {patient.therapistId.profilePhotoUrl ? (
                                  <img
                                    src={patient.therapistId.profilePhotoUrl}
                                    alt={patient.therapistId.firstName}
                                    className="w-7 h-7 rounded-md object-cover flex-shrink-0"
                                  />
                                ) : (
                                  <div className="w-7 h-7 rounded-md bg-[#8174A9] flex items-center justify-center text-white font-bold text-[8px] flex-shrink-0">
                                    {`${patient.therapistId.firstName?.[0] || ''}${patient.therapistId.lastName?.[0] || ''}`}
                                  </div>
                                )}
                                <div className="min-w-0">
                                  <h3 className="text-[10px] font-bold text-[#1E293B] leading-tight truncate">
                                    {patient.therapistId.firstName}{' '}
                                    {patient.therapistId.lastName}
                                  </h3>
                                  <p className="text-[9px] text-[#1E293B] mt-0.5">
                                    {Array.isArray(
                                      patient.therapistId.specialization
                                    ) &&
                                    patient.therapistId.specialization.length >
                                      0
                                      ? typeof patient.therapistId
                                          .specialization[0] === 'object'
                                        ? patient.therapistId.specialization[0]
                                            ?.name || 'Provider'
                                        : 'Provider'
                                      : 'Provider'}
                                  </p>
                                </div>
                              </div>
                              <div className="flex items-center gap-1.5 text-[#00A86B] font-semibold text-[10px] mt-2">
                                <span>✓</span> Assigned
                              </div>
                            </div>
                          ) : (
                            <div>
                              <button
                                onClick={() => {
                                  setAgencySelectedPatient(patient)
                                  setAllAgencyProviders([])
                                  setAssignProviderSelected(null)
                                  setOpenAssignProviderDialog(true)
                                  if (patient?._id)
                                    fetchAgencyProviders(patient._id)
                                }}
                                className="flex items-center gap-1.5 bg-white border border-[#E2E8F0] rounded-[12px] px-3 py-1.5 text-[#64748B] text-[10px] font-semibold hover:bg-[#F1F5F9] transition-colors w-fit"
                              >
                                <span className="text-[11px]">✦</span> AI Assign
                              </button>
                              <div className="flex items-center gap-1.5 text-[#F59E0B] font-semibold text-[10px] mt-2 whitespace-nowrap">
                                <span>⊘</span> Unassigned
                              </div>
                            </div>
                          )}
                        </td> */}

                      <td className="px-8 py-8">
                        <div>{patient?.sessionCount || 'N/A'}</div>
                      </td>

                      <td className="px-8 py-8">
                        <div className="flex items-center gap-3 text-[#5B5682]">
                          {patient?.nextVisit[0]?.session_slot &&
                          patient?.nextVisit[0]?.session_date ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-7 h-7"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M8 7V3m8 4V3m-9 8h10m-13 9h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v11a2 2 0 002 2z"
                              />
                            </svg>
                          ) : null}
                          <span className="text-[10px] font-semibold ">
                            {patient?.nextVisit[0]?.session_date
                              ? dayjs(
                                  patient?.nextVisit[0]?.session_date
                                ).format('MM/DD/YYYY')
                              : null}
                          </span>

                          <span className="text-[10px] font-semibold ">
                            {patient?.nextVisit[0]?.session_slot
                              ? patient?.nextVisit[0]?.session_slot
                              : null}
                          </span>
                        </div>
                      </td>

                      <td className="px-8 py-8">
                        <IconButton
                          size="small"
                          onClick={e => {
                            ;(handleOpenMenu(e, patient),
                              setAgencySelectedPatient(patient))
                          }}
                          sx={{ color: 'gray' }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className="flex justify-center mt-3">
        <div className="flex items-center gap-4">
          <RowsPerPageDropdown
            pageSize={pageSize}
            onPageSizeChange={newPageSize => {
              handlePageSizeChange(newPageSize)
              if (ourPageSize && ourPageSize !== newPageSize) {
                setCurrentPage(1)
              }
            }}
          />
        </div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          className="mt-2 mt-md-0"
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </div>
      <ToastContainer />
      <InfoPopup
        open={openNoTherapistPopup}
        onClose={() => setOpenNoTherapistPopup(false)}
        title="Assign Provider"
        message="Please assign provider first"
        buttonColor="primary"
      />

      <AreYouSurePopup
        open={openRemoveAgencyConfirm}
        onClose={() => setOpenRemoveAgencyConfirm(false)}
        onConfirm={async () => {
          if (agencySelectedPatient?._id) {
            setIsRemovingPatient(true)
            await handleRemoveAgency(agencySelectedPatient._id)
            setIsRemovingPatient(false)
            setOpenRemoveAgencyConfirm(false)
          }
        }}
        title="Remove From Agency"
        message={`Are you sure you want to remove ${agencySelectedPatient?.firstName || ''} ${agencySelectedPatient?.lastName || ''} from this agency?`}
        confirmText="Remove"
        cancelText="Cancel"
        isProcessing={isRemovingPatient}
        type="danger"
      />

      <AreYouSurePopup
        open={openRemoveInvitationConfirm}
        onClose={() => setOpenRemoveInvitationConfirm(false)}
        onConfirm={async () => {
          if (agencySelectedPatient?._id) {
            setIsRemovingInvitation(true)
            await handleRemoveInvitation(agencySelectedPatient._id)
            setIsRemovingInvitation(false)
            setOpenRemoveInvitationConfirm(false)
          }
        }}
        title="Revoke Invitation"
        message={`Are you sure you want to remove the invitation for ${
          agencySelectedPatient?.patientId
            ? `${agencySelectedPatient.patientId.firstName || ''} ${agencySelectedPatient.patientId.lastName || ''}`.trim()
            : agencySelectedPatient?.patientName ||
              agencySelectedPatient?.patientEmail ||
              'this patient'
        }?`}
        confirmText="Remove"
        cancelText="Cancel"
        isProcessing={isRemovingInvitation}
        type="danger"
      />
      <Dialog open={openToggle} onClose={() => setOpenToggle(false)}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to {isActive ? 'deactivate' : 'activate'} this
          provider?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenToggle(false)} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPatientStatusDialog}
        onClose={() =>
          !patientStatusLoading && setOpenPatientStatusDialog(false)
        }
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 30px 80px rgba(0, 0, 0, 0.15)',
          },
        }}
      >
        <DialogTitle sx={{ px: 3, pt: 3, pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: '50%',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: patientStatusCurrent ? '#FFE5E5' : '#E6F7EE',
              }}
            >
              {patientStatusCurrent ? (
                <ToggleOffIcon sx={{ fontSize: 24, color: '#E53E3E' }} />
              ) : (
                <ToggleOnIcon sx={{ fontSize: 24, color: '#2F855A' }} />
              )}
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: 18, fontWeight: 700, color: '#312E4A' }}
              >
                {patientStatusCurrent ? 'Disable Patient' : 'Enable Patient'}
              </Typography>
              <Typography sx={{ fontSize: 13, color: '#6C6B7E' }}>
                {patientStatusCurrent
                  ? 'Confirm disabling access for this patient.'
                  : 'Confirm enabling access for this patient.'}
              </Typography>
            </Box>
          </Box>
        </DialogTitle>

        <Divider sx={{ my: 1, borderColor: '#E6E8F0' }} />

        <DialogContent sx={{ px: 3, pb: 2 }}>
          <Typography
            sx={{
              fontSize: '15px',
              color: '#4B4A5A',
              mb: 1.5,
              lineHeight: 1.7,
            }}
          >
            Are you sure you want to{' '}
            {patientStatusCurrent ? 'disable' : 'enable'}{' '}
            <strong>
              {patientStatusTarget?.patientName ||
                patientStatusTarget?.name ||
                'this patient'}
            </strong>
            ?
          </Typography>
          <Typography sx={{ fontSize: '13px', color: '#6C6B7E' }}>
            This action will{' '}
            {patientStatusCurrent
              ? 'prevent the patient from accessing agency features'
              : 'restore access for the patient'}
            .
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={() => setOpenPatientStatusDialog(false)}
            disabled={patientStatusLoading}
            variant="outlined"
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              color: '#4B4A5A',
              borderColor: '#E6E8F0',
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmPatientStatus}
            variant="contained"
            color={patientStatusCurrent ? 'error' : 'success'}
            disabled={patientStatusLoading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              boxShadow: patientStatusCurrent
                ? '0 12px 20px rgba(229, 62, 62, 0.18)'
                : '0 12px 20px rgba(45, 133, 90, 0.18)',
            }}
          >
            {patientStatusLoading
              ? 'Saving...'
              : patientStatusCurrent
                ? 'Disable Patient'
                : 'Enable Patient'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Provider Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 1.5,
            pt: 2.5,
            px: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: 'error.lighter',
            }}
          >
            <DeleteForeverIcon sx={{ fontSize: 28, color: 'error.main' }} />
          </Box>
          <Box>
            <Typography variant="h6" component="span" fontWeight={600}>
              Delete Provider
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              display="block"
              mt={0.5}
            >
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ px: 3, py: 1 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to permanently delete this provider? All
            associated data will be removed.
          </Typography>
          {selectedProviderForDelete && (
            <Box
              sx={{
                p: 2,
                mb: 2,
                bgcolor: 'grey.50',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Provider:</strong> {''}
                {selectedProviderForDelete.firstName}{' '}
                {selectedProviderForDelete.lastName}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Email:</strong> {''}
                {selectedProviderForDelete.email}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            p: 2.5,
            px: 3,
            gap: 1.5,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          <Button
            onClick={handleCloseDeleteDialog}
            disabled={deleteLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={deleteLoading}
            variant="contained"
            color="error"
            startIcon={
              deleteLoading ? null : <DeleteForeverIcon sx={{ fontSize: 18 }} />
            }
          >
            {deleteLoading ? 'Deleting...' : 'Delete Provider'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openReverifyDialog} onClose={handleCloseReverifyDialog}>
        <DialogTitle>Re-Verify Provider</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 1.5 }}>
            Are you sure you want to initiate re-verification for{' '}
            <strong>{reverifyProviderName || 'this provider'}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseReverifyDialog}
            variant="outlined"
            disabled={reverifyLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleReverifyProvider}
            color="primary"
            variant="contained"
            disabled={reverifyLoading}
          >
            {reverifyLoading ? 'Re-verifying...' : 'Confirm Re-Verification'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Commission Dialog */}
      <Dialog
        open={openCommissionDialog}
        onClose={handleCloseCommissionDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Per Claim System Fee & Discount</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {commissionData?.plan_id?.name && (
            <Typography sx={{ pt: 0.5 }}>
              <strong>Subscribed Plan:</strong> {commissionData?.plan_id?.name}
            </Typography>
          )}
          {commissionData?.plan_id?.monthly_fee &&
            commissionData?.plan_id?.anual_fee && (
              <Typography variant="body1" sx={{ mb: 0.2 }}>
                <strong>Subscription Fee:</strong>{' '}
                {commissionData?.frequency === 'Month'
                  ? `$${commissionData?.plan_id?.monthly_fee}`
                  : `$${commissionData?.plan_id?.anual_fee}`}
              </Typography>
            )}
          {commissionData?.plan_id?.commission && (
            <Typography variant="body1" sx={{ mb: 1.6 }}>
              <strong>Per-Claim System Fee:</strong>{' '}
              {`${commissionData?.plan_id?.commission}%`}
            </Typography>
          )}
          <TextField
            label="Per Claim System Fee"
            type="number"
            value={monthlyCommission}
            sx={{ mb: 1.6, mt: 1.6 }}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : monthlyCommission
                setMonthlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee percentage"
          />
          {/* <TextField
            label="Yearly Commission"
            type="number"
            value={yearlyCommission}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places)
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d+(\.\d{0,2})?)?$/)
                  ? inputValue
                  : yearlyCommission
                setYearlyCommission(validValue)
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the yearly commission percentage"
          /> */}
          <TextField
            label="Per Claim System Fee Discount"
            type="number"
            value={providerFeeDiscountPercent}
            onChange={e => {
              const inputValue = e.target.value
              // Allow only positive decimal numbers (up to 2 decimal places) between 0-100
              if (inputValue === '' || parseFloat(inputValue) >= 0) {
                const validValue = inputValue.match(/^(\d*(\.\d{0,3})?)?$/)
                  ? inputValue
                  : providerFeeDiscountPercent
                // Check if value is within valid range (0-100)
                if (
                  validValue === '' ||
                  (parseFloat(validValue) >= 0 && parseFloat(validValue) <= 100)
                ) {
                  setProviderFeeDiscountPercent(validValue)
                }
              }
            }}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            helperText="Enter the Per Claim System Fee Discount (0-100)"
          />

          <Typography variant="body1" sx={{ mb: 1.6, mt: 1.6 }}>
            <strong>Final Per Claim Fee:</strong> {finalperclaimfeeDisplay}%
          </Typography>
          {/* if Final Per Claim Fee less than or equal to 0, show a error message */}
          {finalperclaimfee <= 0 && (
            <Typography variant="body2" color="error">
              The entered percentages result in a platform fee of 0 or less.
              Please update the values to maintain a minimum positive fee.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseCommissionDialog}
            disabled={commissionLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateCommission}
            variant="contained"
            color="primary"
            disabled={commissionLoading}
          >
            {commissionLoading ? 'Updating...' : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Provider Verification Dialog */}
      <Dialog
        open={openVerificationDialog}
        onClose={handleCloseVerificationDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: '90vh',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2,
            pt: 3,
            px: 3,
            background: 'linear-gradient(135deg, #5BC0BE 0%, #4a9d9b 100%)',
            color: 'white',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <VerifiedUserIcon sx={{ fontSize: 28 }} />
            <Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, letterSpacing: 0.5 }}
              >
                Provider Verification Details
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={handleCloseVerificationDialog}
            size="small"
            sx={{
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ pt: '1rem !important', pb: 2, px: 3, bgcolor: '#f8f9fa' }}
        >
          {selectedProvider && (
            <>
              <Grid container spacing={3}>
                {/* Licenses Section */}
                {selectedProvider.licenses &&
                  selectedProvider.licenses.length > 0 && (
                    <Grid item xs={12}>
                      <Card
                        elevation={0}
                        sx={{
                          borderRadius: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'white',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                          },
                        }}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              mb: 3,
                              pb: 2,
                              borderBottom: '2px solid',
                              borderColor: '#5BC0BE',
                            }}
                          >
                            <BadgeIcon
                              sx={{ color: '#5BC0BE', fontSize: 28 }}
                            />
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                color: '#2c3e50',
                                letterSpacing: 0.3,
                              }}
                            >
                              License Information
                            </Typography>
                          </Box>
                          <Grid container spacing={2}>
                            {selectedProvider.licenses.map(
                              (license: any, index: number) => (
                                <Grid item xs={12} key={index}>
                                  <Card
                                    elevation={0}
                                    sx={{
                                      p: 2.5,
                                      borderRadius: 2,
                                      border: '1px solid',
                                      borderColor: '#e9ecef',
                                      bgcolor: '#f8f9fa',
                                    }}
                                  >
                                    <Grid container spacing={3}>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License Number
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 600,
                                            color: '#2c3e50',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.licenseNumber || '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License State
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 500,
                                            color: '#495057',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.licenseState || '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          Expiry Date
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 500,
                                            color: '#495057',
                                            fontSize: '0.95rem',
                                          }}
                                        >
                                          {license.expiryDate
                                            ? formatDateMMDDYY(
                                                license.expiryDate
                                              )
                                            : '--'}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={6}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: '#6c757d',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: 0.5,
                                            fontSize: '0.7rem',
                                            mb: 0.5,
                                            display: 'block',
                                          }}
                                        >
                                          License Status
                                        </Typography>
                                        <Chip
                                          label={license.licenseStatus || '--'}
                                          color={
                                            license.licenseStatus === 'Active'
                                              ? 'success'
                                              : 'default'
                                          }
                                          size="small"
                                          sx={{
                                            fontWeight: 600,
                                            height: 28,
                                            '& .MuiChip-label': {
                                              px: 1.5,
                                            },
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </Card>
                                </Grid>
                              )
                            )}
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                {/* Verification Status Section - at end of content */}
                <Grid item xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      bgcolor: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          mb: 3,
                          pb: 2,
                          borderBottom: '2px solid',
                          borderColor: '#5BC0BE',
                        }}
                      >
                        <VerifiedUserIcon
                          sx={{ color: '#5BC0BE', fontSize: 28 }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: '#2c3e50',
                            letterSpacing: 0.3,
                          }}
                        >
                          Verification Status
                        </Typography>
                      </Box>
                      <Stack spacing={0} sx={{ width: '100%' }}>
                        {[
                          {
                            title: 'License Verification',
                            status:
                              selectedProvider.verificationStatus || 'N/A',
                            message:
                              selectedProvider.verificationMessage || '--',
                          },
                          {
                            title: 'FACIS Verification',
                            status:
                              selectedProvider.verificationFacisStatus || 'N/A',
                            message:
                              selectedProvider.verificationFacisMessage || '--',
                          },
                          {
                            title: 'Board Verification',
                            status:
                              selectedProvider.verificationBoardStatus || 'N/A',
                            message:
                              selectedProvider.verificationBoardMessage || '--',
                          },
                        ].map((item, index) => {
                          const getChipStyle = (s: string) => {
                            const sUpper = String(s).toLowerCase()
                            if (sUpper === 'verified')
                              return {
                                // bgcolor: 'rgba(46, 125, 50, 0.12)',
                                color: '#2e7d32',
                                // border: '1px solid rgba(46, 125, 50, 0.5)',
                              }
                            if (sUpper === 'pending')
                              return {
                                // bgcolor: 'rgba(237, 108, 2, 0.12)',
                                color: '#ed6c02',
                                // border: '1px solid rgba(237, 108, 2, 0.5)',
                              }
                            if (sUpper === 'expired' || sUpper === 'rejected')
                              return {
                                // bgcolor: 'rgba(211, 47, 47, 0.12)',
                                color: '#d32f2f',
                                // border: '1px solid rgba(211, 47, 47, 0.5)',
                              }
                            if (sUpper === 'submitted')
                              return {
                                // bgcolor: 'rgba(2, 136, 209, 0.12)', // soft info blue background
                                color: '#0288d1', // info main
                                // border: '1px solid rgba(2, 136, 209, 0.5)',
                              }

                            return {
                              // bgcolor: 'rgba(108, 117, 125, 0.12)',
                              color: '#6c757d',
                              // border: '1px solid rgba(108, 117, 125, 0.3)',
                            }
                          }
                          const chipStyle = getChipStyle(item.status)
                          return (
                            <Box
                              key={item.title}
                              sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 2,
                                py: 1.75,
                                px: 1.5,
                                borderBottom: index < 2 ? '1px solid' : 'none',
                                borderColor: '#e9ecef',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: 180,
                                  flexShrink: 0,
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: '#2c3e50',
                                    fontWeight: 700,
                                    fontSize: '0.875rem',
                                    letterSpacing: 0.3,
                                    lineHeight: 1.4,
                                  }}
                                >
                                  {item.title}
                                </Typography>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    mt: 2,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: '#868e96',
                                      fontWeight: 500,
                                      fontSize: '0.7rem',
                                    }}
                                  >
                                    Status:
                                  </Typography>

                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontWeight: 800,
                                      fontSize: '0.8rem',
                                      ...chipStyle,
                                    }}
                                  >
                                    {item.status}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: '#495057',
                                  fontSize: '0.8125rem',
                                  lineHeight: 1.5,
                                  flex: 1,
                                  pt: 0.25,
                                }}
                              >
                                {item.message}
                              </Typography>
                            </Box>
                          )
                        })}
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Block Reason - at very end of content */}
                {selectedProvider.blockReason && (
                  <Grid item xs={12}>
                    <Alert
                      severity="error"
                      icon={<BlockIcon />}
                      sx={{
                        borderRadius: 2,
                        '& .MuiAlert-message': { width: '100%' },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, mb: 0.5 }}
                      >
                        Block Reason
                      </Typography>
                      <Typography variant="body2">
                        {selectedProvider.blockReason}
                      </Typography>
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </DialogContent>
        {selectedProvider && (
          <>
            <Divider sx={{ borderColor: '#e9ecef' }} />
            <DialogActions
              sx={{
                px: 3,
                py: 2.5,
                bgcolor: '#f8f9fa',
                borderTop: '1px solid',
                borderColor: '#e9ecef',
                justifyContent: 'flex-end',
                gap: 1.5,
              }}
            >
              {selectedProvider.status?.toLowerCase() !== 'active' && (
                <Button
                  onClick={handleApproveTherapist}
                  variant="contained"
                  color="success"
                  disabled={approveLoading || blockLoading}
                  startIcon={<CheckCircleIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                    },
                  }}
                >
                  {approveLoading ? 'Approving...' : 'Approve Provider'}
                </Button>
              )}
              {selectedProvider.status?.toLowerCase() !== 'blocked' && (
                <Button
                  onClick={handleOpenBlockReasonDialog}
                  variant="contained"
                  color="error"
                  disabled={approveLoading || blockLoading}
                  startIcon={<BlockIcon />}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
                    },
                  }}
                >
                  Block Provider
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Block Reason Dialog */}
      <Dialog
        open={openBlockReasonDialog}
        onClose={handleCloseBlockReasonDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            pb: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <BlockIcon sx={{ color: 'error.main', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Block Provider
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: '1rem !important', pb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Please provide a reason for blocking this provider. This reason will
            be displayed to the provider in to their account.
          </Typography>
          <TextField
            label="Reason for Blocking"
            multiline
            rows={4}
            fullWidth
            value={blockReason}
            onChange={e => setBlockReason(e.target.value)}
            placeholder="Enter the reason for blocking this provider..."
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
            helperText={`${blockReason.length} characters`}
          />
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCloseBlockReasonDialog}
            variant="outlined"
            disabled={blockLoading}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmBlock}
            variant="contained"
            color="error"
            disabled={blockLoading || !blockReason.trim()}
            startIcon={<BlockIcon />}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
              '&:hover': {
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
              },
            }}
          >
            {blockLoading ? 'Blocking...' : 'Confirm Block'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPatientProfileDialog}
        onClose={handleClosePatientProfile}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: '24px',
            minHeight: '80vh',
            maxHeight: '90vh',
            display: 'block',
            overflowY: 'auto',
          },
        }}
      >
        <DialogTitle sx={{ p: 4, pb: 2, position: 'relative' }}>
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <Avatar sx={{ width: 56, height: 56, bgcolor: '#7A6FA1' }}>
                  {selectedPatientProfile?.firstName?.charAt(0) || 'P'}
                </Avatar>
                <div>
                  <div className="text-2xl font-bold text-[#312E4A]">
                    {selectedPatientProfile?.firstName}{' '}
                    {selectedPatientProfile?.lastName}
                  </div>
                  {/* <div className="text-sm font-medium text-[#7A6FA1]">
                    ACTIVE PATIENT · Case ID:{' '}
                    {selectedPatientProfile?._id || 'N/A'}
                  </div> */}
                  <div className="mt-2">
                    Status:
                    {selectedPatientProfile?.status === 'active' ? (
                      <span className="inline-flex items-center px-3 py-1 rounded-sm bg-[#E6F7EE] text-[#2F855A] text-[10px] font-semibold">
                        Active
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-3 py-1 rounded-sm bg-[#FEE2E2] text-[#C53030] text-[10px] font-semibold">
                        Inactive
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <IconButton
                onClick={handleClosePatientProfile}
                sx={{ color: '#7A6FA1' }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div className="grid grid-cols-1 gap-3 mt-6 md:grid-cols-3">
              <Card
                sx={{
                  p: 3,
                  borderRadius: 3,
                  boxShadow: '0 10px 30px rgba(79, 70, 229, 0.08)',
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, color: '#7A6FA1', fontWeight: 700 }}
                >
                  DEMOGRAPHICS
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Gender
                </Typography>
                <Typography sx={{ mb: 1, fontWeight: 600 }}>
                  {selectedPatientProfile?.gender
                    ? selectedPatientProfile.gender.charAt(0).toUpperCase() +
                      selectedPatientProfile.gender.slice(1)
                    : 'N/A'}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Member Since
                </Typography>
                <Typography sx={{ mb: 1, fontWeight: 600 }}>
                  {selectedPatientProfile?.memberSince
                    ? new Date(
                        selectedPatientProfile.memberSince
                      ).toLocaleDateString()
                    : 'N/A'}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Show Profile
                </Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {selectedPatientProfile?.showProfileToProviders
                    ? 'Yes'
                    : 'No'}
                </Typography>
              </Card>

              <Card
                sx={{
                  p: 3,
                  borderRadius: 3,
                  boxShadow: '0 10px 30px rgba(79, 70, 229, 0.08)',
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, color: '#7A6FA1', fontWeight: 700 }}
                >
                  CONTACT INFORMATION
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Email
                </Typography>
                <Typography sx={{ mb: 1, fontWeight: 600 }}>
                  {selectedPatientProfile?.email || 'N/A'}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Address
                </Typography>
                <Typography sx={{ mb: 1, fontWeight: 600 }}>
                  {selectedPatientProfile?.addressLine1
                    ? `${selectedPatientProfile.addressLine1}, ${selectedPatientProfile.city}, ${selectedPatientProfile.state} ${selectedPatientProfile.postalCode}`
                    : 'N/A'}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Timezone
                </Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {selectedPatientProfile?.timeZone || 'N/A'}
                </Typography>
              </Card>

              <Card
                sx={{
                  p: 3,
                  borderRadius: 3,
                  boxShadow: '0 10px 30px rgba(79, 70, 229, 0.08)',
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, color: '#7A6FA1', fontWeight: 700 }}
                >
                  CLINICAL CONTEXT
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Primary Care Need
                </Typography>
                <Typography sx={{ mb: 1, fontWeight: 600 }}>
                  {selectedPatientProfile?.careNeeds?.length > 0
                    ? selectedPatientProfile.careNeeds[0]
                    : 'N/A'}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Consent Signed
                </Typography>
                <Typography sx={{ mb: 1, fontWeight: 600 }}>
                  {selectedPatientProfile?.hasSignedConsent ? 'Yes' : 'No'}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                  Last Login
                </Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {selectedPatientProfile?.lastLogin
                    ? new Date(
                        selectedPatientProfile.lastLogin
                      ).toLocaleString()
                    : 'N/A'}
                </Typography>
              </Card>
            </div>
          </div>
        </DialogTitle>
        <DialogContent sx={{ px: 4, pb: 4, overflowY: 'visible' }}>
            
          <div className="mt-8">
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: '#312E4A', mb: 2 }}
            >
            Care Needs & Goals
            </Typography>
            <Card
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: '#FCFCFF',
                border: '1px solid #E8EAF3',
              }}
            >
              <Typography sx={{ color: '#4B3E7C', fontStyle: 'italic' }}>
                {selectedPatientProfile?.careGoal}
              </Typography>
              <div className="flex items-center gap-3 mt-4">
                <Avatar
                  sx={{ width: 36, height: 36, bgcolor: '#7A6FA1', fontSize: 14 }}
                  aria-label="entered-by"
                >
                  {(
                    `${selectedPatientProfile?.firstName?.charAt(0) || ''}${selectedPatientProfile?.lastName?.charAt(0) || ''}`
                  ).toUpperCase() || 'PL'}
                </Avatar>
                {/* <div className="text-sm text-[#6B7280]">
                  <div style={{ fontWeight: 600, color: '#4B3E7C' }}>Entered by Agency:</div>
                  <div>
                    {selectedPatientProfile?.updatedAt
                      ? dayjs(selectedPatientProfile.updatedAt).format('DD/MM/YYYY')
                      : 'Unknown date'}
                  </div>
                </div> */}
              </div>
            </Card>
          </div>
        </DialogContent>
      </Dialog>
      <TablePopup
        open={openTablePopup}
        handleClose={() => setOpenTablePopup(false)}
        data={tableData}
        title={tableTitle}
      />
      <PendingApprovalReviewDialog
        open={openApprovalReview}
        onClose={handleCloseApprovalReview}
        approval={selectedApproval}
        onApprove={approvalId => {
          handleApproveProvider(approvalId)
          handleCloseApprovalReview()
        }}
        onReject={approvalId => {
          handleRejectProvider(approvalId)
          handleCloseApprovalReview()
        }}
      />

      {/* Right side Drawer for Pending Approval Review */}

      {/* Row Dropdown Menu */}
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleCloseMenu}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
            border: '1px solid #f0f0f0',
            minWidth: '220px',
            mt: 0.5,
            p: 0.5,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {(activeTab !== 'invitations' ||
          agencySelectedPatient?.status === 'accepted') && (
          <MenuItem
            onClick={() => {
              const patientToView =
                activeTab === 'invitations'
                  ? agencySelectedPatient?.patientId || agencySelectedPatient
                  : agencySelectedPatient
              if (patientToView) {
                handleViewProfile(patientToView)
              } else {
                toast.error(
                  'Patient profile is not available for this invitation.'
                )
              }
            }}
            sx={{
              borderRadius: '8px',
              py: 1.2,
              px: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              color: '#4B3E7C',
              fontWeight: 500,
              fontSize: '14px',
              '&:hover': {
                bgcolor: '#f8f7fd',
              },
            }}
          >
            <VisibilityIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
            View Profile
          </MenuItem>
        )}
        {activeTab !== 'invitations' && (
          <>
            <MenuItem
              onClick={() =>
                handleOpenInsuranceDialog(agencySelectedPatient?._id)
              }
              sx={{
                borderRadius: '8px',
                py: 1.2,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                color: '#4B3E7C',
                fontWeight: 500,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: '#f8f7fd',
                },
              }}
            >
              <CalendarTodayIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
              View Insurances
            </MenuItem>

            {/* <MenuItem
              onClick={handleOpenAssignProvider}
              sx={{
                borderRadius: '8px',
                py: 1.2,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                color: '#4B3E7C',
                fontWeight: 500,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: '#f8f7fd',
                },
              }}
            >
              <PersonAddAlt1Icon sx={{ fontSize: 18, color: '#7A6FA1' }} />
              Assign Provider
            </MenuItem>

            <MenuItem
              onClick={() => {
                handleCloseMenu()
                if (!agencySelectedPatient?.therapistId) {
                  setOpenNoTherapistPopup(true)
                } else {
                  setOpenAddSessionChoiceDialog(true)
                }
              }}
              sx={{
                borderRadius: '8px',
                py: 1.2,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                color: '#4B3E7C',
                fontWeight: 500,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: '#f8f7fd',
                },
              }}
            >
              <EventAvailableIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
              Add Session
            </MenuItem> */}
            <MenuItem
              onClick={() => {
                navigate(
                  `/agency-contracts?patientId=${agencySelectedPatient?._id}`
                )
              }}
              sx={{
                borderRadius: '8px',
                py: 1.2,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                color: '#4B3E7C',
                fontWeight: 500,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: '#f8f7fd',
                },
              }}
            >
              <EventAvailableIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />
              View Contract and Session
            </MenuItem>

            {hasPermission('patient.edit') && (
              <MenuItem
                onClick={() =>
                  handleOpenPatientStatusDialog(agencySelectedPatient)
                }
                disabled={patientStatusLoading}
                sx={{
                  borderRadius: '8px',
                  py: 1.2,
                  px: 2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  color: isPatientActive(agencySelectedPatient)
                    ? '#E53E3E'
                    : '#2F855A',
                  fontWeight: 500,
                  fontSize: '14px',
                  '&:hover': {
                    bgcolor: isPatientActive(agencySelectedPatient)
                      ? '#FFF5F5'
                      : '#ECFDF5',
                  },
                }}
              >
                {isPatientActive(agencySelectedPatient) ? (
                  <ToggleOffIcon sx={{ fontSize: 18, color: '#E53E3E' }} />
                ) : (
                  <ToggleOnIcon sx={{ fontSize: 18, color: '#2F855A' }} />
                )}
                {isPatientActive(agencySelectedPatient)
                  ? 'Disable Patient'
                  : 'Enable Patient'}
              </MenuItem>
            )}

            <Divider sx={{ my: 1, borderColor: '#f0f0f0' }} />

            {hasPermission('patient.delete') && (
              <MenuItem
                onClick={() => {
                  handleCloseMenu()
                  setOpenRemoveAgencyConfirm(true)
                }}
                sx={{
                  borderRadius: '8px',
                  py: 1.2,
                  px: 2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  color: '#e0533c',
                  fontWeight: 500,
                  fontSize: '14px',
                  '&:hover': {
                    bgcolor: '#fff5f5',
                  },
                }}
              >
                <DeleteOutlineIcon sx={{ fontSize: 18, color: '#e0533c' }} />{' '}
                Remove From Agency
              </MenuItem>
            )}
          </>
        )}

        {activeTab === 'invitations' &&
          agencySelectedPatient?.status !== 'accepted' && (
            <MenuItem
              onClick={() => {
                handleCloseMenu()
                setOpenRemoveInvitationConfirm(true)
              }}
              sx={{
                borderRadius: '8px',
                py: 1.2,
                px: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                color: '#e0533c',
                fontWeight: 500,
                fontSize: '14px',
                '&:hover': {
                  bgcolor: '#fff5f5',
                },
              }}
            >
              <DeleteOutlineIcon sx={{ fontSize: 18, color: '#e0533c' }} />{' '}
              Revoke from Invitation
            </MenuItem>
          )}
      </Menu>

      {/* Assign Provider Dialog — PillarAssign */}
      <Dialog
        open={openAssignProviderDialog}
        onClose={handleCloseAssignProvider}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: '0 24px 48px rgba(75, 62, 124, 0.2)',
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #6B5FA6 0%, #8B7EC8 100%)',
            px: 3,
            pt: 3,
            pb: 2.5,
            position: 'relative',
          }}
        >
          <IconButton
            onClick={handleCloseAssignProvider}
            size="small"
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              bgcolor: 'rgba(255,255,255,0.15)',
              color: 'white',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
            }}
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <Typography
            sx={{
              fontSize: '26px',
              fontWeight: 800,
              color: 'white',
              letterSpacing: 0.5,
            }}
          >
            PillarAssign
          </Typography>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.8,
              mt: 1,
              px: 1.5,
              py: 0.5,
              borderRadius: '20px',
              bgcolor: 'rgba(255,255,255,0.18)',
              border: '1px solid rgba(255,255,255,0.25)',
            }}
          >
            <span style={{ fontSize: '10px' }}>⚡</span>
            <Typography
              sx={{
                fontSize: '10px',
                fontWeight: 700,
                color: 'white',
                letterSpacing: '1px',
              }}
            >
              POWERED BY AI BASED MATCH MAKING ENGINE
            </Typography>
          </Box>
        </Box>

        {/* Provider Cards */}
        <DialogContent
          sx={{
            p: 2.5,
            bgcolor: '#F5F4FB',
            maxHeight: '65vh',
            overflowY: 'auto',
            '&::-webkit-scrollbar': { width: '5px' },
            '&::-webkit-scrollbar-thumb': {
              bgcolor: '#D0C9EE',
              borderRadius: '4px',
            },
          }}
        >
          {assignProviderLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
              <CircularProgress sx={{ color: '#7A6FA1' }} />
            </Box>
          ) : allAgencyProviders.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 6 }}>
              <Typography sx={{ color: '#8A82A5', fontSize: '14px' }}>
                No providers found
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {allAgencyProviders.map((prov, idx) => {
                const isAssigning =
                  assignProviderSubmitting &&
                  assignProviderSelected?._id === prov._id
                const initials = `${(prov.firstName as string)?.[0] || ''}${(prov.lastName as string)?.[0] || ''}`
                const location =
                  [prov.city, prov.state].filter(Boolean).join(', ') || '--'
                const score = prov.score != null ? `${prov.score}` : '--'
                const specList = Array.isArray(prov.specialization)
                  ? prov.specialization
                  : []
                const specialtyName =
                  specList.length > 0 &&
                  typeof specList[0] === 'object' &&
                  specList[0] !== null
                    ? ((specList[0] as Record<string, unknown>)
                        .name as string) || '--'
                    : '--'
                return (
                  <Box
                    key={prov._id as string}
                    sx={{
                      bgcolor: 'white',
                      borderRadius: '16px',
                      p: 2.5,
                      border: '1px solid #E8E4F4',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    }}
                  >
                    <Box
                      sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}
                    >
                      {/* Score */}
                      <Box sx={{ textAlign: 'center', minWidth: 52, pt: 0.5 }}>
                        <Typography
                          sx={{
                            fontSize: '26px',
                            fontWeight: 800,
                            color: '#7A6FA1',
                            lineHeight: 1,
                          }}
                        >
                          {score}%
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '9px',
                            fontWeight: 700,
                            color: '#A09AB8',
                            letterSpacing: '1px',
                            mt: 0.3,
                          }}
                        >
                          SCORE
                        </Typography>
                      </Box>

                      {/* Info + bars */}
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                          }}
                        >
                          <Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                              }}
                            >
                              <Avatar
                                src={prov.profilePhotoUrl as string}
                                sx={{
                                  width: 28,
                                  height: 28,
                                  bgcolor: '#7A6FA1',
                                  fontSize: '11px',
                                  color: 'white',
                                }}
                              >
                                {initials}
                              </Avatar>
                              <Box>
                                <Typography
                                  sx={{
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: '#1E1743',
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {prov.firstName as string}{' '}
                                  {prov.lastName as string}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: '11px',
                                    color: '#8A82A5',
                                    mt: 0.2,
                                  }}
                                >
                                  {specialtyName}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                mt: 0.5,
                                ml: 0.5,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: '11px', color: '#8A82A5' }}
                              >
                                📍 {location}
                              </Typography>
                            </Box>
                          </Box>
                          <Button
                            variant="outlined"
                            size="small"
                            disabled={assignProviderSubmitting}
                            onClick={() => handleAssignProvider(prov)}
                            sx={{
                              borderRadius: '10px',
                              textTransform: 'none',
                              fontWeight: 600,
                              fontSize: '12px',
                              px: 2,
                              py: 0.8,
                              minWidth: 96,
                              borderColor: '#7A6FA1',
                              color: '#7A6FA1',
                              '&:hover': {
                                bgcolor: '#7A6FA1',
                                color: 'white',
                                borderColor: '#7A6FA1',
                              },
                            }}
                          >
                            {isAssigning ? (
                              <CircularProgress
                                size={14}
                                sx={{ color: 'inherit' }}
                              />
                            ) : (
                              'Assign Now'
                            )}
                          </Button>
                        </Box>

                        {/* Progress bars */}
                        {/* <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                          {[
                            { label: 'AVAILABILITY', value: null },
                            { label: 'SPECIALTY MATCH', value: null },
                            { label: 'COMPLIANCE', value: null },
                          ].map(row => (
                            <Box key={row.label} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                              <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#A09AB8', letterSpacing: '0.8px', minWidth: 100 }}>
                                {row.label}
                              </Typography>
                              <Box sx={{ flex: 1, height: 6, bgcolor: '#EDE9F8', borderRadius: '4px', overflow: 'hidden' }}>
                                <Box sx={{ width: '0%', height: '100%', bgcolor: '#7A6FA1', borderRadius: '4px' }} />
                              </Box>
                              <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#A09AB8', minWidth: 28, textAlign: 'right' }}>
                                --
                              </Typography>
                            </Box>
                          ))}
                        </Box> */}
                      </Box>
                    </Box>
                  </Box>
                )
              })}
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Patient Insurance Verification Dialog */}
      <Dialog
        open={openInsuranceDialog}
        onClose={() => setOpenInsuranceDialog(false)}
        maxWidth={patientInsurances.length > 1 ? 'lg' : 'sm'}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '28px',
            bgcolor: '#F3F2F8',
            boxShadow: '0 20px 40px rgba(75, 62, 124, 0.15)',
            overflow: 'hidden',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <IconButton
          onClick={() => setOpenInsuranceDialog(false)}
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            color: '#8A82A5',
            bgcolor: 'white',
            boxShadow: '0 4px 10px rgba(75, 62, 124, 0.08)',
            '&:hover': { bgcolor: '#F3F2F8', color: '#4B3E7C' },
          }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
        <DialogContent
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-thumb': {
              bgcolor: 'rgba(75, 62, 124, 0.2)',
              borderRadius: '3px',
            },
          }}
        >
          {/* Top Badge Icon */}
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '18px',
              bgcolor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 16px rgba(75, 62, 124, 0.06)',
              mb: 2.5,
            }}
          >
            <VerifiedUserIcon sx={{ fontSize: 28, color: '#4B3E7C' }} />
          </Box>

          {/* Header text */}
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              color: '#1E1743',
              textAlign: 'center',
              fontFamily: 'Outfit, sans-serif',
              mb: 0.5,
            }}
          >
            Insurance Verification
          </Typography>
          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 700,
              color: '#8A82A5',
              letterSpacing: '1.5px',
              textAlign: 'center',
              mb: 3,
            }}
          >
            PATIENT:{' '}
            {`${agencySelectedPatient?.firstName || ''} ${agencySelectedPatient?.lastName || ''}`.trim() ||
              agencySelectedPatient?.patientName ||
              agencySelectedPatient?.name ||
              'N/A'}
          </Typography>

          {patientInsurancesLoading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 260,
                width: '100%',
              }}
            >
              <CircularProgress sx={{ color: '#4B3E7C' }} />
            </Box>
          ) : patientInsurances.length === 0 ? (
            // Empty State
            <Box
              sx={{
                bgcolor: 'white',
                borderRadius: '24px',
                p: 4,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.02)',
                mb: 3,
              }}
            >
              <InfoIcon sx={{ fontSize: 40, color: '#8A82A5', mb: 2 }} />
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 600,
                  color: '#1E1743',
                  mb: 1,
                }}
              >
                No Insurances Found
              </Typography>
              <Typography sx={{ fontSize: '13px', color: '#7E769B', mb: 3 }}>
                This patient does not have any active insurance policies
                registered at this moment.
              </Typography>
              <Button
                onClick={() =>
                  handleOpenInsuranceDialog(agencySelectedPatient?._id)
                }
                variant="contained"
                sx={{
                  bgcolor: '#4B3E7C',
                  color: 'white',
                  borderRadius: '14px',
                  py: 1.5,
                  px: 3,
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '14px',
                  '&:hover': { bgcolor: '#3b3064' },
                }}
              >
                Retry Fetching
              </Button>
            </Box>
          ) : (
            // Insurance Details View
            <Box sx={{ width: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  gap: 3,
                  overflowX: 'auto',
                  pb: 2,
                  mb: 1.5,
                  scrollSnapType: 'x mandatory',
                  scrollbarWidth: 'thin',
                  '&::-webkit-scrollbar': {
                    height: '6px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    bgcolor: 'rgba(75, 62, 124, 0.2)',
                    borderRadius: '3px',
                  },
                }}
              >
                {patientInsurances.map((currentIns, index) => (
                  <Stack
                    key={currentIns?._id || index}
                    spacing={2}
                    sx={{
                      minWidth: patientInsurances.length > 1 ? '40%' : '100%',
                      width: patientInsurances.length > 1 ? undefined : '100%',
                      flexShrink: 0,
                      scrollSnapAlign: 'start',
                      bgcolor: 'white',
                      borderRadius: '24px',
                      p: 3,
                      boxShadow: '0 8px 24px rgba(75, 62, 124, 0.04)',
                      border: '1px solid rgba(224, 220, 240, 0.7)',
                      boxSizing: 'border-box',
                    }}
                  >
                    {patientInsurances.length > 1 && (
                      <Chip
                        label={`INSURANCE POLICY #${index + 1} of ${patientInsurances.length}`}
                        sx={{
                          alignSelf: 'flex-start',
                          bgcolor: '#4B3E7C',
                          color: 'white',
                          fontWeight: 800,
                          fontSize: '9px',
                          height: '20px',
                          mb: 0.5,
                        }}
                      />
                    )}

                    {/* Provider Name Card Info */}
                    <Box
                      sx={{
                        bgcolor: '#F8F7FD',
                        borderRadius: '20px',
                        p: 2.5,
                        textAlign: 'center',
                        border: '1px solid rgba(224, 220, 240, 0.5)',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '9px',
                          fontWeight: 800,
                          color: '#7A6FA1',
                          letterSpacing: '1.2px',
                          mb: 0.5,
                        }}
                      >
                        INSURANCE PROVIDER
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '18px',
                          fontWeight: 750,
                          color: '#4B3E7C',
                          fontFamily: 'Outfit, sans-serif',
                        }}
                      >
                        {currentIns.insuranceName ||
                          currentIns.providerName ||
                          'N/A'}
                      </Typography>
                    </Box>

                    {/* Details Grid */}
                    <Grid container spacing={1.5}>
                      <Grid item xs={6}>
                        <Box
                          sx={{
                            bgcolor: '#F8F7FD',
                            borderRadius: '16px',
                            p: 2,
                            border: '1px solid rgba(224, 220, 240, 0.3)',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '9px',
                              fontWeight: 700,
                              color: '#9089B2',
                              mb: 0.5,
                            }}
                          >
                            MEMBER ID
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '13px',
                              fontWeight: 700,
                              color: '#312B54',
                            }}
                          >
                            {currentIns.memberId ||
                              currentIns.policyNumber ||
                              'N/A'}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={6}>
                        <Box
                          sx={{
                            bgcolor: '#F8F7FD',
                            borderRadius: '16px',
                            p: 2,
                            border: '1px solid rgba(224, 220, 240, 0.3)',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '9px',
                              fontWeight: 700,
                              color: '#9089B2',
                              mb: 0.5,
                            }}
                          >
                            GROUP ID
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '13px',
                              fontWeight: 700,
                              color: '#312B54',
                            }}
                          >
                            {currentIns.groupId ||
                              currentIns.groupNumber ||
                              'N/A'}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={6}>
                        <Box
                          sx={{
                            bgcolor: '#F8F7FD',
                            borderRadius: '16px',
                            p: 2,
                            border: '1px solid rgba(224, 220, 240, 0.3)',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '9px',
                              fontWeight: 700,
                              color: '#9089B2',
                              mb: 0.5,
                            }}
                          >
                            ELIGIBILITY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '13px',
                              fontWeight: 700,
                              color: '#312B54',
                            }}
                          >
                            {currentIns.status ||
                              currentIns.eligibilityStatus ||
                              'Verified'}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={6}>
                        <Box
                          sx={{
                            bgcolor: '#F8F7FD',
                            borderRadius: '16px',
                            p: 2,
                            border: '1px solid rgba(224, 220, 240, 0.3)',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '9px',
                              fontWeight: 700,
                              color: '#9089B2',
                              mb: 0.5,
                            }}
                          >
                            INSURANCE TYPE
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '13px',
                              fontWeight: 700,
                              color: '#312B54',
                            }}
                          >
                            {currentIns.insuranceType || 'N/A'}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    {/* Insurance Card Images */}
                    {(currentIns.insuranceFrontUrl ||
                      currentIns.insuranceBackUrl) && (
                      <Box sx={{ display: 'flex', gap: 1.5, width: '100%' }}>
                        {currentIns.insuranceFrontUrl && (
                          <Box
                            component="img"
                            src={currentIns.insuranceFrontUrl}
                            alt="Insurance Front"
                            sx={{
                              display: 'block',
                              width: '50%',
                              minWidth: 0,
                              maxWidth: '100%',
                              height: 110,
                              aspectRatio: '4 / 3',
                              objectFit: 'cover',
                              borderRadius: '16px',
                              border: '1px solid rgba(224, 220, 240, 0.5)',
                            }}
                          />
                        )}
                        {currentIns.insuranceBackUrl && (
                          <Box
                            component="img"
                            src={currentIns.insuranceBackUrl}
                            alt="Insurance Back"
                            sx={{
                              display: 'block',
                              width: '50%',
                              minWidth: 0,
                              maxWidth: '100%',
                              height: 110,
                              aspectRatio: '4 / 3',
                              objectFit: 'cover',
                              borderRadius: '16px',
                              border: '1px solid rgba(224, 220, 240, 0.5)',
                            }}
                          />
                        )}
                      </Box>
                    )}
                  </Stack>
                ))}
              </Box>

              {/* Verify Again Button */}
              {/* <Button
                onClick={() => handleOpenInsuranceDialog(agencySelectedPatient?._id)}
                variant="contained"
                sx={{
                  bgcolor: '#7C6FA6',
                  color: 'white',
                  borderRadius: '16px',
                  py: 2,
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '15px',
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: '#5B4E8C',
                    boxShadow: 'none',
                  },
                  mt: 1,
                  width: '100%',
                }}
              >
                Verify Insurance Again
              </Button> */}
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {/* Invite Provider Dialog */}
      <Dialog
        open={openInviteDialog}
        onClose={!inviteLoading ? handleCloseInviteDialog : undefined}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: { borderRadius: '24px', padding: '16px' },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: '#4B3E7C', fontWeight: 'bold' }}
          >
            Invite Patient
          </Typography>
          <IconButton
            onClick={handleCloseInviteDialog}
            disabled={inviteLoading}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
            <Box>
              <Typography
                variant="body2"
                sx={{ color: '#4B3E7C', fontWeight: 'medium', mb: 1 }}
              >
                Full Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Jane Smith"
                value={inviteName}
                onChange={e => setInviteName(e.target.value)}
                disabled={inviteLoading}
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                  },
                }}
              />
            </Box>
            <Box>
              <Typography
                variant="body2"
                sx={{ color: '#4B3E7C', fontWeight: 'medium', mb: 1 }}
              >
                Email Address
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="patient@example.com"
                value={inviteEmail}
                onChange={e => setInviteEmail(e.target.value)}
                disabled={inviteLoading}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailOutlineIcon
                        sx={{ color: '#A0AEC0', fontSize: 20 }}
                      />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                  },
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ px: 3, pb: 2, pt: 0, justifyContent: 'center', gap: 2 }}
        >
          <Button
            onClick={handleCloseInviteDialog}
            disabled={inviteLoading}
            variant="outlined"
            sx={{
              borderRadius: '12px',
              color: '#4B3E7C',
              borderColor: '#4B3E7C',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 4,
              py: 1,
              '&:hover': {
                borderColor: '#4B3E7C',
                backgroundColor: 'rgba(75, 62, 124, 0.04)',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleInviteProvider}
            disabled={inviteLoading}
            variant="contained"
            startIcon={<MailOutlineIcon />}
            sx={{
              borderRadius: '12px',
              backgroundColor: '#7A6FA1',
              color: 'white',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 4,
              py: 1,
              '&:hover': {
                backgroundColor: '#6c6191',
              },
            }}
          >
            {inviteLoading ? 'Sending...' : 'Send Invitation'}
          </Button>
        </DialogActions>
      </Dialog>
      {openPatientAddDialog && (
        <OpenPatientAddDialog
          open={openPatientAddDialog}
          setOpen={setOpenPatientAddDialog}
          fromDataPatienSignupData={fromDataPatienSignupData}
          setFromDataPatienSignupData={setFromDataPatienSignupData}
          handlePatientAdd={handlePatientAdd}
        />
      )}

      {/* Choice Dialog for Adding Session/Contract */}
      <Dialog
        open={openAddSessionChoiceDialog}
        onClose={() => setOpenAddSessionChoiceDialog(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '24px',
            p: 3,
            boxShadow: '0px 12px 30px rgba(0, 0, 0, 0.08)',
          },
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            fontWeight: 800,
            fontSize: '1.35rem',
            color: '#1E1743',
            mb: 1.5,
            textAlign: 'center',
          }}
        >
          Add Session Option
        </DialogTitle>
        <DialogContent sx={{ p: 0, mb: 3, textAlign: 'center' }}>
          <Typography sx={{ fontSize: '14px', color: '#8A82A5', mb: 3 }}>
            Choose whether you would like to schedule a direct clinical visit
            session or create a session contract.
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              mb: 1.5,
              color: '#1E1743',
              textAlign: 'left',
            }}
          >
            Select Service Type*
          </Typography>
          <Select
            value={selectedServiceId}
            onChange={e => setSelectedServiceId(e.target.value)}
            displayEmpty
            fullWidth
            placeholder="Select Service Id"
            required
            sx={{ marginBottom: '15px' }}
          >
            <MenuItem value="" disabled>
              Select Service Type
            </MenuItem>
            {therapistIdPackage?.map(service => (
              <MenuItem key={service._id} value={service._id}>
                {service.name}
              </MenuItem>
            ))}
          </Select>
          {!selectedServiceId && (
            <Typography
              sx={{
                fontSize: '12px',
                color: '#e53e3e',
                mt: 0.5,
                mb: 1,
                textAlign: 'left',
              }}
            >
              Please select a service type to continue.
            </Typography>
          )}
          <Stack spacing={2}>
            <Button
              variant="contained"
              disabled={!selectedServiceId}
              onClick={() => {
                setOpenAddSessionChoiceDialog(false)
                setDsSelectedSlots({})
                setDsSelectedDate(today)
                setDsPaymentMethod('')
                setDsMonthOffset(0)
                setDsSelectedInsuranceId('')
                setDsSelectedPaymentMethodId('')
                setDsCardholderName('')
                setDsNewInsuranceName('')
                setDsPolicyId('')
                if (agencySelectedPatient?._id) {
                  fetchAcInsurances(agencySelectedPatient._id)
                  fetchAcPaymentMethods(agencySelectedPatient._id)
                }
                setOpenDirectSessionDialog(true)
              }}
              sx={{
                bgcolor: '#7A6FA1',
                '&:hover': { bgcolor: '#6c6191' },
                '&.Mui-disabled': { bgcolor: '#e0ddf2', color: '#b0a8cc' },
                borderRadius: '16px',
                textTransform: 'none',
                fontWeight: 700,
                py: 1.6,
                fontSize: '0.95rem',
                boxShadow: 'none',
              }}
            >
              Add Direct Session
            </Button>
            <Button
              variant="outlined"
              disabled={!selectedServiceId}
              onClick={() => {
                setOpenAddSessionChoiceDialog(false)
                openContractDialogForPatient(agencySelectedPatient)
              }}
              sx={{
                borderColor: '#7A6FA1',
                color: '#7A6FA1',
                borderWidth: '1.5px',
                '&:hover': {
                  borderColor: '#6c6191',
                  bgcolor: '#F3F0FF',
                  borderWidth: '1.5px',
                },
                borderRadius: '16px',
                textTransform: 'none',
                fontWeight: 700,
                py: 1.6,
                fontSize: '0.95rem',
              }}
            >
              Add Contract
            </Button>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 0, justifyContent: 'center' }}>
          <Button
            onClick={() => setOpenAddSessionChoiceDialog(false)}
            sx={{
              color: '#8A82A5',
              fontWeight: 700,
              textTransform: 'none',
              fontSize: '14px',
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* ───── Direct Session Booking Dialog ───── */}
      <Dialog
        open={openDirectSessionDialog}
        onClose={() => !dsSubmitting && setOpenDirectSessionDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '24px',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #faf9ff 0%, #f3f0ff 100%)',
            boxShadow: '0 32px 80px rgba(74, 62, 124, 0.18)',
          },
        }}
      >
        {/* Dialog Header */}
        <DialogTitle sx={{ p: 0 }}>
          <div
            style={{
              background: 'linear-gradient(135deg, #4B3E7C 0%, #7A6FA1 100%)',
              padding: '24px 28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  background: 'rgba(255,255,255,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <EventAvailableIcon sx={{ color: 'white', fontSize: 22 }} />
              </div>
              <div>
                <div
                  style={{
                    color: 'white',
                    fontWeight: 800,
                    fontSize: '1.15rem',
                    lineHeight: 1.2,
                  }}
                >
                  Add Direct Session
                </div>
                <div
                  style={{
                    color: 'rgba(255,255,255,0.75)',
                    fontSize: '12px',
                    marginTop: '2px',
                  }}
                >
                  {agencySelectedPatient
                    ? `For ${agencySelectedPatient.firstName || ''} ${agencySelectedPatient.lastName || ''}`.trim()
                    : 'Select date & time'}
                </div>
              </div>
            </div>
            <IconButton
              onClick={() => setOpenDirectSessionDialog(false)}
              disabled={dsSubmitting}
              sx={{
                color: 'rgba(255,255,255,0.8)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', color: 'white' },
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <div
            style={{
              marginTop: '8px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
            }}
          >
            {/* Calendar + Slots Row */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '16px',
              }}
            >
              {/* Calendar */}
              <div
                style={{
                  background: 'white',
                  borderRadius: '18px',
                  border: '1.5px solid #e8e4f3',
                  padding: '20px',
                  boxShadow: '0 2px 12px rgba(74, 62, 124, 0.06)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '16px',
                  }}
                >
                  <button
                    onClick={() => setDsMonthOffset(m => m - 1)}
                    style={{
                      background: '#f3f0ff',
                      border: 'none',
                      borderRadius: '10px',
                      width: '32px',
                      height: '32px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#7A6FA1',
                      fontSize: '16px',
                      fontWeight: 700,
                    }}
                  >
                    &lt;
                  </button>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      color: '#1E1743',
                    }}
                  >
                    {dsMonthStart.toLocaleString('en-US', {
                      month: 'long',
                      year: 'numeric',
                    })}
                  </div>
                  <button
                    onClick={() => setDsMonthOffset(m => m + 1)}
                    style={{
                      background: '#f3f0ff',
                      border: 'none',
                      borderRadius: '10px',
                      width: '32px',
                      height: '32px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#7A6FA1',
                      fontSize: '16px',
                      fontWeight: 700,
                    }}
                  >
                    &gt;
                  </button>
                </div>

                {/* Day headers */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '4px',
                    marginBottom: '8px',
                  }}
                >
                  {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(d => (
                    <div
                      key={d}
                      style={{
                        textAlign: 'center',
                        fontSize: '11px',
                        fontWeight: 600,
                        color: '#8A82A5',
                        padding: '4px 0',
                      }}
                    >
                      {d}
                    </div>
                  ))}
                </div>

                {/* Dates grid */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '4px',
                  }}
                >
                  {dsMonthDates.map((d, index) => {
                    if (d === null)
                      return (
                        <div key={`e-${index}`} style={{ aspectRatio: '1' }} />
                      )
                    const key = dsFormatDateKey(d)
                    const disabled = dsIsPastDate(d)
                    const isActive =
                      dsSelectedDate && dsFormatDateKey(dsSelectedDate) === key
                    const dateSelected = Boolean(dsSelectedSlots[key])
                    return (
                      <button
                        key={key}
                        onClick={() => !disabled && setDsSelectedDate(d)}
                        disabled={disabled}
                        style={{
                          aspectRatio: '1',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '10px',
                          border: dateSelected
                            ? '2px solid #7A6FA1'
                            : isActive
                              ? '2px solid #7A6FA1'
                              : '1.5px solid #ede9f8',
                          background: isActive
                            ? '#7A6FA1'
                            : dateSelected
                              ? '#ede9f8'
                              : disabled
                                ? '#fafafa'
                                : 'white',
                          color: isActive
                            ? 'white'
                            : disabled
                              ? '#d0ccde'
                              : '#1E1743',
                          cursor: disabled ? 'not-allowed' : 'pointer',
                          fontSize: '12px',
                          fontWeight: isActive ? 700 : 500,
                          position: 'relative',
                          transition: 'all 0.15s ease',
                        }}
                      >
                        {d.getDate()}
                        {dateSelected && (
                          <div
                            style={{
                              position: 'absolute',
                              top: '-3px',
                              right: '-3px',
                              width: '8px',
                              height: '8px',
                              background: '#7A6FA1',
                              borderRadius: '50%',
                              border: '2px solid white',
                            }}
                          />
                        )}
                      </button>
                    )
                  })}
                </div>

                <div
                  style={{
                    marginTop: '12px',
                    fontSize: '11px',
                    color: '#8A82A5',
                    textAlign: 'center',
                  }}
                >
                  Select a date to view available slots
                </div>
              </div>

              {/* Time Slots */}
              <div
                style={{
                  background: 'white',
                  borderRadius: '18px',
                  border: '1.5px solid #e8e4f3',
                  padding: '20px',
                  boxShadow: '0 2px 12px rgba(74, 62, 124, 0.06)',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '14px',
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      color: '#1E1743',
                    }}
                  >
                    Available Slots
                  </div>
                  {dsSelectedDate && (
                    <div
                      style={{
                        fontSize: '11px',
                        color: '#8A82A5',
                        background: '#f3f0ff',
                        borderRadius: '8px',
                        padding: '4px 10px',
                      }}
                    >
                      {dsFormatDateLong(dsSelectedDate)}
                    </div>
                  )}
                </div>

                {!dsSelectedDate ? (
                  <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <CalendarTodayIcon
                      sx={{ fontSize: 40, color: '#d0ccde', mb: 1 }}
                    />
                    <div style={{ fontSize: '13px', color: '#8A82A5' }}>
                      Select a date first
                    </div>
                  </div>
                ) : dsLoadingSlots ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '40px 0',
                    }}
                  >
                    <CircularProgress size={28} sx={{ color: '#7A6FA1' }} />
                    <div
                      style={{
                        marginTop: '10px',
                        fontSize: '12px',
                        color: '#8A82A5',
                      }}
                    >
                      Loading slots...
                    </div>
                  </div>
                ) : dsSlots.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <AccessTimeIcon
                      sx={{ fontSize: 40, color: '#d0ccde', mb: 1 }}
                    />
                    <div style={{ fontSize: '13px', color: '#8A82A5' }}>
                      No slots available
                    </div>
                    <div
                      style={{
                        fontSize: '11px',
                        color: '#b0a8cc',
                        marginTop: '4px',
                      }}
                    >
                      Try a different date
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      overflowY: 'auto',
                      maxHeight: '280px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                      paddingRight: '4px',
                    }}
                  >
                    {dsSlots.map(slot => {
                      const label = `${slot.startTime} – ${slot.endTime}`
                      const dateKey = dsSelectedDate
                        ? dsFormatDateKey(dsSelectedDate)
                        : ''
                      const isSelected =
                        dsSelectedSlots[dateKey]?.startTime ===
                          slot.startTime &&
                        dsSelectedSlots[dateKey]?.endTime === slot.endTime
                      return (
                        <button
                          key={slot._id ?? label}
                          onClick={() =>
                            dsSelectedDate &&
                            dsHandleSelectSlot(dsSelectedDate, slot)
                          }
                          style={{
                            width: '100%',
                            textAlign: 'left',
                            padding: '10px 14px',
                            borderRadius: '12px',
                            border: isSelected
                              ? '2px solid #7A6FA1'
                              : '1.5px solid #ede9f8',
                            background: isSelected
                              ? 'linear-gradient(135deg, #7A6FA1 0%, #9D8FC7 100%)'
                              : 'white',
                            color: isSelected ? 'white' : '#1E1743',
                            cursor: 'pointer',
                            fontWeight: isSelected ? 700 : 500,
                            fontSize: '13px',
                            transition: 'all 0.15s ease',
                            boxShadow: isSelected
                              ? '0 4px 12px rgba(122, 111, 161, 0.3)'
                              : 'none',
                          }}
                        >
                          {label}
                        </button>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>

            {/* Selected Sessions Summary — always visible */}
            <div
              style={{
                background: 'white',
                borderRadius: '18px',
                border: '1.5px solid #e8e4f3',
                padding: '16px 20px',
                boxShadow: '0 2px 12px rgba(74, 62, 124, 0.06)',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '12px',
                }}
              >
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: '14px',
                    color: '#1E1743',
                  }}
                >
                  Selected Sessions
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    color: '#8A82A5',
                    background: '#f3f0ff',
                    borderRadius: '8px',
                    padding: '3px 10px',
                  }}
                >
                  {Object.keys(dsSelectedSlots).length} / 10 selected
                </div>
              </div>
              {Object.keys(dsSelectedSlots).length === 0 ? (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '16px 0',
                    fontSize: '13px',
                    color: '#8A82A5',
                  }}
                >
                  No sessions selected yet. Select dates and time slots above.
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    maxHeight: '160px',
                    overflowY: 'auto',
                  }}
                >
                  {Object.entries(dsSelectedSlots)
                    .sort(([a], [b]) => a.localeCompare(b))
                    .map(([dateKey, slot]) => {
                      const parts = dateKey.split('-').map(Number)
                      const dateObj = new Date(parts[0], parts[1] - 1, parts[2])
                      return (
                        <div
                          key={dateKey}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            background: '#f8f7fd',
                            borderRadius: '12px',
                            padding: '10px 14px',
                            border: '1px solid #e8e4f3',
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: '13px',
                                color: '#1E1743',
                              }}
                            >
                              {dsFormatDateLong(dateObj)}
                            </div>
                            <div
                              style={{
                                fontSize: '12px',
                                color: '#8A82A5',
                                marginTop: '2px',
                              }}
                            >
                              {slot.startTime} – {slot.endTime}
                            </div>
                          </div>
                          <button
                            onClick={() => dsRemoveSlot(dateKey)}
                            style={{
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              color: '#b0a8cc',
                              padding: '4px',
                              borderRadius: '8px',
                            }}
                          >
                            <CloseIcon sx={{ fontSize: 18 }} />
                          </button>
                        </div>
                      )
                    })}
                </div>
              )}
            </div>

            {/* Payment Method */}
            <div
              style={{
                background: 'white',
                borderRadius: '18px',
                border: '1.5px solid #e8e4f3',
                padding: '16px 20px',
                boxShadow: '0 2px 12px rgba(74, 62, 124, 0.06)',
              }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontSize: '14px',
                  color: '#1E1743',
                  marginBottom: '14px',
                }}
              >
                Payment Method <span style={{ color: '#e53e3e' }}>*</span>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                {[
                  {
                    value: 'out_of_pocket',
                    label: 'Self-Pay (Out of Pocket)',
                    icon: '💳',
                  },
                  { value: 'insurance', label: 'Insurance-Billed', icon: '🏥' },
                ].map(opt => (
                  <button
                    key={opt.value}
                    onClick={() => setDsPaymentMethod(opt.value as any)}
                    style={{
                      flex: 1,
                      padding: '14px',
                      borderRadius: '14px',
                      cursor: 'pointer',
                      border:
                        dsPaymentMethod === opt.value
                          ? '2px solid #7A6FA1'
                          : '1.5px solid #ede9f8',
                      background:
                        dsPaymentMethod === opt.value
                          ? 'linear-gradient(135deg, #7A6FA1 0%, #9D8FC7 100%)'
                          : 'white',
                      color:
                        dsPaymentMethod === opt.value ? 'white' : '#4B3E7C',
                      fontWeight: 600,
                      fontSize: '13px',
                      transition: 'all 0.15s ease',
                      boxShadow:
                        dsPaymentMethod === opt.value
                          ? '0 6px 20px rgba(122, 111, 161, 0.35)'
                          : 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <span style={{ fontSize: '18px' }}>{opt.icon}</span>
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>

            {/* ── Insurance Selection (when insurance-billed) ── */}
            {dsPaymentMethod === 'insurance' && (
              <div
                style={{
                  background:
                    'linear-gradient(135deg, #f3f0ff 0%, #ede9f8 100%)',
                  borderRadius: '14px',
                  padding: '16px 18px',
                  border: '1.5px solid #d8d3f0',
                }}
              >
                <Select
                  value={dsSelectedInsuranceId}
                  onChange={e => {
                    setDsSelectedInsuranceId(e.target.value)
                    setDsNewInsuranceName('')
                    setDsPolicyId('')
                  }}
                  displayEmpty
                  fullWidth
                  size="small"
                  endAdornment={
                    dsSelectedInsuranceId ? (
                      <InputAdornment
                        position="end"
                        sx={{ marginRight: '16px' }}
                      >
                        <IconButton
                          size="small"
                          onClick={e => {
                            e.stopPropagation()
                            setDsSelectedInsuranceId('')
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }
                  sx={{
                    borderRadius: '10px',
                    background: 'white',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#7A6FA1',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#4B3E7C',
                      borderWidth: '2px',
                    },
                    '& .MuiSelect-select': {
                      color: dsSelectedInsuranceId ? '#1E1743' : '#8A82A5',
                    },
                    marginBottom: '12px',
                  }}
                >
                  <MenuItem value="" disabled>
                    <em style={{ color: '#8A82A5', fontStyle: 'normal' }}>
                      Select saved insurance
                    </em>
                  </MenuItem>
                  {acInsurances.length === 0 && (
                    <MenuItem value="__none" disabled>
                      No saved insurance cards found
                    </MenuItem>
                  )}
                  {acInsurances.map((ins: any) => (
                    <MenuItem key={ins._id} value={ins._id}>
                      {ins.insuranceName ||
                        ins.payer_name ||
                        ins.name ||
                        'Insurance'}{' '}
                      — {ins.policyNumber || ins.policy_number || ''}
                    </MenuItem>
                  ))}
                </Select>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '12px',
                  }}
                >
                  <div
                    style={{ flex: 1, height: '1px', background: '#d8d3f0' }}
                  />
                  <span
                    style={{
                      fontSize: '12px',
                      color: '#8A82A5',
                      fontWeight: 600,
                    }}
                  >
                    OR
                  </span>
                  <div
                    style={{ flex: 1, height: '1px', background: '#d8d3f0' }}
                  />
                </div>

                <Autocomplete
                  freeSolo
                  fullWidth
                  options={insuranceOptions}
                  getOptionLabel={(option: any) =>
                    typeof option === 'string'
                      ? option
                      : option.payer_name || option.name || ''
                  }
                  loading={insuranceLoading}
                  inputValue={dsNewInsuranceName}
                  onInputChange={(_e, val) => {
                    setDsNewInsuranceName(val)
                    setDsSelectedInsuranceId('')
                    setInsuranceSearchTerm(val)
                  }}
                  onChange={(_e, val) => {
                    if (val && typeof val === 'object') {
                      setDsNewInsuranceName(val.payer_name || val.name || '')
                      setDsSelectedInsuranceId('')
                      setDsPayerId(val._id || '')
                      setDsPolicyId('')
                    }
                  }}
                  renderOption={(props, option: any) => (
                    <li {...props} key={option._id || option.payer_name}>
                      <div>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: '13px',
                            color: '#1E1743',
                          }}
                        >
                          {option.payer_name || option.name}
                        </div>
                        {option.payerid && (
                          <div style={{ fontSize: '11px', color: '#8A82A5' }}>
                            ID: {option.payerid}
                          </div>
                        )}
                      </div>
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder="Search New Insurance..."
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          background: 'white',
                          '&.Mui-focused fieldset': {
                            borderColor: '#4B3E7C',
                            borderWidth: '2px',
                          },
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {insuranceLoading ? (
                              <CircularProgress
                                size={16}
                                sx={{ color: '#7A6FA1' }}
                              />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
                {dsNewInsuranceName && (
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Member / Policy ID"
                    value={dsPolicyId}
                    onChange={e => setDsPolicyId(e.target.value)}
                    sx={{
                      mt: 1.5,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        background: 'white',
                        '&.Mui-focused fieldset': {
                          borderColor: '#4B3E7C',
                          borderWidth: '2px',
                        },
                      },
                    }}
                  />
                )}
              </div>
            )}

            {/* ── Add Card Information (when self-pay) ── */}
            {dsPaymentMethod === 'out_of_pocket' && (
              <div
                style={{
                  background:
                    'linear-gradient(135deg, #f3f0ff 0%, #ede9f8 100%)',
                  borderRadius: '14px',
                  padding: '16px 18px',
                  border: '1.5px solid #d8d3f0',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '14px',
                  }}
                >
                  <div
                    style={{
                      width: '22px',
                      height: '22px',
                      borderRadius: '50%',
                      background:
                        'linear-gradient(135deg, #4B3E7C 0%, #7A6FA1 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <span
                      style={{
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 700,
                      }}
                    >
                      ✓
                    </span>
                  </div>
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      color: '#1E1743',
                    }}
                  >
                    Add Card Information
                  </span>
                </div>

                <Select
                  value={dsSelectedPaymentMethodId}
                  onChange={e => {
                    const val = e.target.value
                    setDsSelectedPaymentMethodId(val)
                    if (val) {
                      setDsCardholderName('')
                      const pm = acPaymentMethods.find(
                        (p: any) => p._id === val
                      )
                      setSelectedPaymentMethod(pm || null)
                    } else {
                      setSelectedPaymentMethod(null)
                    }
                  }}
                  displayEmpty
                  fullWidth
                  size="small"
                  endAdornment={
                    dsSelectedPaymentMethodId ? (
                      <InputAdornment
                        position="end"
                        sx={{ marginRight: '16px' }}
                      >
                        <IconButton
                          size="small"
                          onClick={e => {
                            e.stopPropagation()
                            setDsSelectedPaymentMethodId('')
                            setSelectedPaymentMethod(null)
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ) : null
                  }
                  sx={{
                    borderRadius: '10px',
                    background: 'white',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#d8d3f0',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#4B3E7C',
                      borderWidth: '2px',
                    },
                    '& .MuiSelect-select': {
                      color: dsSelectedPaymentMethodId ? '#1E1743' : '#8A82A5',
                    },
                    marginBottom: '12px',
                  }}
                >
                  <MenuItem value="">
                    <em style={{ color: '#8A82A5', fontStyle: 'normal' }}>
                      Select saved payment method
                    </em>
                  </MenuItem>
                  {acPaymentMethods.map((pm: any) => (
                    <MenuItem key={pm._id} value={pm._id}>
                      {pm.cardBrand?.toUpperCase() || 'Card'} **** {pm.last4} —{' '}
                      {pm.cardOwner}
                    </MenuItem>
                  ))}
                </Select>

                <StripeCardInput
                  cardholderName={dsCardholderName}
                  onCardholderNameChange={setDsCardholderName}
                  cardComplete={cardComplete}
                  onCardCompleteChange={setCardComplete}
                  selectedPaymentMethod={selectedPaymentMethod}
                  onStripeReady={(stripe, elements) => {
                    setStripeInstance(stripe)
                    setElementsInstance(elements)
                  }}
                  isSaving={isSavingNewCard}
                />
              </div>
            )}
          </div>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1.5 }}>
          <Button
            onClick={() => {
              setOpenDirectSessionDialog(false)
              setDsSelectedSlots({})
              setDsSelectedDate(today)
              setDsPaymentMethod('')
              setDsMonthOffset(0)
              setSelectedPaymentMethod(null)
            }}
            disabled={dsSubmitting}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#8A82A5',
              borderRadius: '12px',
              px: 3,
              '&:hover': { bgcolor: '#f3f0ff' },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleDirectSessionSubmit}
            disabled={
              dsSubmitting ||
              Object.keys(dsSelectedSlots).length === 0 ||
              !dsPaymentMethod
            }
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              background: 'linear-gradient(135deg, #4B3E7C 0%, #7A6FA1 100%)',
              borderRadius: '12px',
              px: 4,
              py: 1.2,
              boxShadow: '0 6px 20px rgba(74, 62, 124, 0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #3d3266 0%, #6c6191 100%)',
              },
              '&.Mui-disabled': { background: '#ede9f8', color: '#b0a8cc' },
            }}
          >
            {dsSubmitting ? (
              <>
                <CircularProgress size={16} sx={{ color: 'white', mr: 1 }} />
                Adding...
              </>
            ) : (
              `Add ${Object.keys(dsSelectedSlots).length || ''} Session${Object.keys(dsSelectedSlots).length !== 1 ? 's' : ''}`
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Direct Session Snackbar */}
      <Snackbar
        open={dsSnackbar.open}
        autoHideDuration={3500}
        onClose={() => setDsSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setDsSnackbar(prev => ({ ...prev, open: false }))}
          severity={dsSnackbar.severity}
          variant="filled"
          sx={{
            borderRadius: '12px',
            fontWeight: 600,
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          }}
        >
          {dsSnackbar.message}
        </Alert>
      </Snackbar>

      {/* ───── Add Contract Dialog ───── */}
      <Dialog
        open={openAddContractDialog}
        onClose={() => !acSubmitting && setOpenAddContractDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '20px',
            overflow: 'hidden',
            background: '#fff',
            boxShadow: '0 32px 80px rgba(74,62,124,0.18)',
            maxHeight: '90vh',
          },
        }}
      >
        {/* Provider Card Header */}
        <div
          style={{
            background: 'linear-gradient(135deg, #4B3E7C 0%, #7A6FA1 100%)',
            padding: '20px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            {/* Therapist Avatar */}
            {agencySelectedPatient?.therapistId &&
            typeof agencySelectedPatient.therapistId === 'object' ? (
              <div style={{ position: 'relative' }}>
                {agencySelectedPatient.therapistId.profilePhotoUrl ? (
                  <img
                    src={agencySelectedPatient.therapistId.profilePhotoUrl}
                    alt="provider"
                    style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '14px',
                      objectFit: 'cover',
                      border: '3px solid rgba(255,255,255,0.3)',
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '14px',
                      background: 'rgba(255,255,255,0.25)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '22px',
                      fontWeight: 700,
                      color: 'white',
                      border: '3px solid rgba(255,255,255,0.3)',
                    }}
                  >
                    {agencySelectedPatient.therapistId.firstName?.[0] || 'T'}
                    {agencySelectedPatient.therapistId.lastName?.[0] || ''}
                  </div>
                )}
                <div
                  style={{
                    position: 'absolute',
                    bottom: '-4px',
                    right: '-4px',
                    background: '#22c55e',
                    borderRadius: '50%',
                    width: '18px',
                    height: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid white',
                  }}
                >
                  <span style={{ color: 'white', fontSize: '9px' }}>✓</span>
                </div>
              </div>
            ) : (
              <div
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '14px',
                  background: 'rgba(255,255,255,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <PersonOutlineIcon sx={{ color: 'white', fontSize: 28 }} />
              </div>
            )}
            <div>
              <div
                style={{
                  color: 'white',
                  fontWeight: 800,
                  fontSize: '16px',
                  lineHeight: 1.2,
                }}
              >
                {agencySelectedPatient?.therapistId &&
                typeof agencySelectedPatient.therapistId === 'object'
                  ? `${agencySelectedPatient.therapistId.firstName || ''} ${agencySelectedPatient.therapistId.lastName || ''}`.trim()
                  : 'Provider'}
              </div>
              <div
                style={{
                  color: 'rgba(255,255,255,0.8)',
                  fontSize: '12px',
                  marginTop: '3px',
                }}
              >
                {(() => {
                  const th = agencySelectedPatient?.therapistId
                  if (!th || typeof th !== 'object') return 'Therapist'
                  const spec =
                    Array.isArray(th.specialization) &&
                    th.specialization.length > 0
                      ? (typeof th.specialization[0] === 'object'
                          ? th.specialization[0]?.name
                          : th.specialization[0]) || 'Therapist'
                      : 'Therapist'
                  return spec
                })()}
              </div>
              <div
                style={{
                  color: 'rgba(255,255,255,0.65)',
                  fontSize: '11px',
                  marginTop: '2px',
                }}
              >
                {agencySelectedPatient?.therapistId?.city || ''}
                {agencySelectedPatient?.therapistId?.state
                  ? `, ${agencySelectedPatient.therapistId.state}`
                  : ''}
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: '6px',
            }}
          >
            {(() => {
              const svc = therapistIdPackage?.find(
                (s: any) => s._id === selectedServiceId
              )
              return svc?.rate || svc?.price ? (
                <div
                  style={{ color: 'white', fontWeight: 800, fontSize: '18px' }}
                >
                  ${svc.rate || svc.price}
                  <span
                    style={{ fontSize: '12px', fontWeight: 400, opacity: 0.8 }}
                  >
                    /session
                  </span>
                </div>
              ) : null
            })()}
            <IconButton
              onClick={() => setOpenAddContractDialog(false)}
              disabled={acSubmitting}
              sx={{
                color: 'rgba(255,255,255,0.8)',
                p: 0.5,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
              }}
            >
              <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </div>
        </div>

        <DialogContent sx={{ p: 0, overflowY: 'auto' }}>
          <div
            style={{
              padding: '20px 24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
            }}
          >
            {/* Number of Sessions */}
            <div>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: '13px',
                  color: '#1E1743',
                  marginBottom: '6px',
                }}
              >
                Number of Sessions *
              </div>
              <div
                style={{
                  fontSize: '11px',
                  color: '#8A82A5',
                  marginBottom: '8px',
                }}
              >
                Enter the number of sessions you'd like to book
              </div>
              <TextField
                fullWidth
                size="small"
                type="number"
                placeholder="Enter sessions"
                value={acSessionsCount}
                onChange={e => setAcSessionsCount(e.target.value)}
                inputProps={{ min: 1 }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                  },
                }}
              />
            </div>

            {/* Contract Summary */}
            {selectedServiceId &&
              (() => {
                const svc = therapistIdPackage?.find(
                  (s: any) => s._id === selectedServiceId
                )
                return svc ? (
                  <div
                    style={{
                      background: '#f8f7fd',
                      borderRadius: '12px',
                      padding: '14px 16px',
                      border: '1px solid #e8e4f3',
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: '13px',
                        color: '#1E1743',
                        marginBottom: '8px',
                      }}
                    >
                      Contract Summary
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          fontSize: '12px',
                        }}
                      >
                        <span style={{ color: '#8A82A5' }}>Service</span>
                        <span style={{ fontWeight: 600, color: '#1E1743' }}>
                          {svc.name}
                        </span>
                      </div>
                      {(svc.duration || svc.session_length) && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            fontSize: '12px',
                          }}
                        >
                          <span style={{ color: '#8A82A5' }}>Duration</span>
                          <span style={{ fontWeight: 600, color: '#1E1743' }}>
                            {svc.duration || svc.session_length} min
                          </span>
                        </div>
                      )}
                      {acSessionsCount &&
                        Number(acSessionsCount) > 0 &&
                        (svc.rate || svc.price) && (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              fontSize: '12px',
                            }}
                          >
                            <span style={{ color: '#8A82A5' }}>
                              Total Estimate
                            </span>
                            <span style={{ fontWeight: 700, color: '#4B3E7C' }}>
                              $
                              {(
                                Number(svc.rate || svc.price) *
                                Number(acSessionsCount)
                              ).toFixed(2)}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                ) : null
              })()}

            {/* Section divider */}
            <div style={{ borderBottom: '1.5px solid #f0edf8' }} />

            {/* Patient's Information */}
            <div>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: '14px',
                  color: '#1E1743',
                  marginBottom: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <PersonOutlineIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />{' '}
                Patient's Information
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '12px',
                }}
              >
                <TextField
                  label="Patient's first name *"
                  size="small"
                  fullWidth
                  value={acFirstName}
                  onChange={e => setAcFirstName(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                    },
                  }}
                />
                <TextField
                  label="Patient's last name *"
                  size="small"
                  fullWidth
                  value={acLastName}
                  onChange={e => setAcLastName(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                    },
                  }}
                />
                <TextField
                  label="Email *"
                  size="small"
                  fullWidth
                  value={acEmail}
                  onChange={e => setAcEmail(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                    },
                  }}
                />
                <TextField
                  label="Phone Number *"
                  size="small"
                  fullWidth
                  value={acPhone}
                  onChange={e => setAcPhone(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                    },
                  }}
                />
                <TextField
                  label="Date of birth (MM/DD/YYYY)"
                  size="small"
                  fullWidth
                  value={acDob}
                  onChange={e => setAcDob(e.target.value)}
                  placeholder="MM/DD/YYYY"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                    },
                  }}
                />
                <Select
                  value={acGender}
                  onChange={e => setAcGender(e.target.value)}
                  displayEmpty
                  size="small"
                  fullWidth
                  sx={{
                    borderRadius: '10px',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#7A6FA1',
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    Patient's gender based on insurer *
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </div>
            </div>

            {/* Patient's Residential Address */}
            <div>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: '14px',
                  color: '#1E1743',
                  marginBottom: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <LocationOnIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />{' '}
                Patient's Residential Address
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                <TextField
                  label="Residential address *"
                  size="small"
                  fullWidth
                  value={acAddress}
                  onChange={e => setAcAddress(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                    },
                  }}
                />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '12px',
                  }}
                >
                  <TextField
                    label="State"
                    size="small"
                    fullWidth
                    value={acState}
                    onChange={e => setAcState(e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                      },
                    }}
                  />
                  <TextField
                    label="City"
                    size="small"
                    fullWidth
                    value={acCity}
                    onChange={e => setAcCity(e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        '&.Mui-focused fieldset': { borderColor: '#7A6FA1' },
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Select Payment Type */}
            <div>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: '14px',
                  color: '#1E1743',
                  marginBottom: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <AccountBalanceIcon sx={{ fontSize: 18, color: '#7A6FA1' }} />{' '}
                Select Payment Type
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                {(
                  [
                    {
                      value: 'insurance',
                      label: 'Insurance-Billed (no patient payment expected)',
                      sub: 'Your insurance is direct, no copay/coinsurance expected.',
                    },
                    {
                      value: 'cash',
                      label: 'Self-Pay (out of pocket)',
                      sub: 'You pay the full amount directly.',
                    },
                    {
                      value: 'copay',
                      label:
                        'Insurance + Self-Pay (copay/coinsurance/deductible)',
                      sub: 'You may be billed for any copay, coinsurance, or deductible.',
                    },
                  ] as const
                ).map(opt => (
                  <button
                    key={opt.value}
                    onClick={() => setAcPaymentType(opt.value)}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px',
                      padding: '14px 16px',
                      borderRadius: '12px',
                      textAlign: 'left',
                      cursor: 'pointer',
                      border:
                        acPaymentType === opt.value
                          ? '2px solid #7A6FA1'
                          : '1.5px solid #e8e4f3',
                      background:
                        acPaymentType === opt.value
                          ? 'linear-gradient(135deg, #f3f0ff 0%, #ede9f8 100%)'
                          : 'white',
                      transition: 'all 0.15s ease',
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        border: `2px solid ${acPaymentType === opt.value ? '#7A6FA1' : '#d0ccde'}`,
                        background:
                          acPaymentType === opt.value ? '#7A6FA1' : 'white',
                        flexShrink: 0,
                        marginTop: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {acPaymentType === opt.value && (
                        <div
                          style={{
                            width: '6px',
                            height: '6px',
                            background: 'white',
                            borderRadius: '50%',
                          }}
                        />
                      )}
                    </div>
                    <div>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: '13px',
                          color: '#1E1743',
                        }}
                      >
                        {opt.label}
                      </div>
                      <div
                        style={{
                          fontSize: '11px',
                          color: '#8A82A5',
                          marginTop: '3px',
                        }}
                      >
                        {opt.sub}
                      </div>
                    </div>
                  </button>
                ))}
              </div>
              <div
                style={{
                  marginTop: '10px',
                  fontSize: '11px',
                  color: '#8A82A5',
                  background: '#f8f7fd',
                  borderRadius: '8px',
                  padding: '8px 12px',
                }}
              >
                ℹ️ Note: Final patient responsibility depends on their plan's
                benefits and approvals.
              </div>
            </div>

            <div
              style={{
                background: 'linear-gradient(135deg, #f3f0ff 0%, #ede9f8 100%)',
                borderRadius: '14px',
                padding: '16px 18px',
                border: '1.5px solid #d8d3f0',
              }}
            >
              {/* Saved insurance dropdown */}
              <Select
                value={acSelectedInsuranceId}
                onChange={e => {
                  setAcSelectedInsuranceId(e.target.value)
                  setAcNewInsuranceName('')
                  setAcPolicyId('')
                }}
                displayEmpty
                fullWidth
                size="small"
                sx={{
                  borderRadius: '10px',
                  background: 'white',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#7A6FA1',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#4B3E7C',
                    borderWidth: '2px',
                  },
                  '& .MuiSelect-select': {
                    color: acSelectedInsuranceId ? '#1E1743' : '#8A82A5',
                  },
                  marginBottom: '12px',
                }}
              >
                <MenuItem value="" disabled>
                  <em style={{ color: '#8A82A5', fontStyle: 'normal' }}>
                    Select saved insurance
                  </em>
                </MenuItem>
                {acInsurances.length === 0 && (
                  <MenuItem value="__none" disabled>
                    No saved insurance cards found
                  </MenuItem>
                )}
                {acInsurances.map((ins: any) => (
                  <MenuItem key={ins._id} value={ins._id}>
                    {ins.insuranceName ||
                      ins.payer_name ||
                      ins.name ||
                      'Insurance'}{' '}
                    — {ins.policyNumber || ins.policy_number || ''}
                  </MenuItem>
                ))}
              </Select>

              {/* OR divider */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '12px',
                }}
              >
                <div
                  style={{ flex: 1, height: '1px', background: '#d8d3f0' }}
                />
                <span
                  style={{
                    fontSize: '12px',
                    color: '#8A82A5',
                    fontWeight: 600,
                  }}
                >
                  OR
                </span>
                <div
                  style={{ flex: 1, height: '1px', background: '#d8d3f0' }}
                />
              </div>

              {/* Searchable New Insurance input */}
              <Autocomplete
                freeSolo
                fullWidth
                options={insuranceOptions}
                getOptionLabel={(option: any) =>
                  typeof option === 'string'
                    ? option
                    : option.payer_name || option.name || ''
                }
                loading={insuranceLoading}
                inputValue={acNewInsuranceName}
                onInputChange={(_e, val) => {
                  setAcNewInsuranceName(val)
                  setAcSelectedInsuranceId('')
                  setInsuranceSearchTerm(val)
                }}
                onChange={(_e, val) => {
                  if (val && typeof val === 'object') {
                    setAcNewInsuranceName(val.payer_name || val.name || '')
                    setAcSelectedInsuranceId('')
                    setAcPayerId(val._id)
                    setAcPolicyId('')
                  }
                }}
                renderOption={(props, option: any) => (
                  <li {...props} key={option._id || option.payer_name}>
                    <div>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: '13px',
                          color: '#1E1743',
                        }}
                      >
                        {option.payer_name || option.name}
                      </div>
                      {option.payerid && (
                        <div style={{ fontSize: '11px', color: '#8A82A5' }}>
                          ID: {option.payerid}
                        </div>
                      )}
                    </div>
                  </li>
                )}
                renderInput={params => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Search New Insurance..."
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        background: 'white',
                        '&.Mui-focused fieldset': {
                          borderColor: '#4B3E7C',
                          borderWidth: '2px',
                        },
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {insuranceLoading ? (
                            <CircularProgress
                              size={16}
                              sx={{ color: '#7A6FA1' }}
                            />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
              {acNewInsuranceName && (
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Member / Policy ID"
                  value={acPolicyId}
                  onChange={e => setAcPolicyId(e.target.value)}
                  sx={{
                    mt: 1.5,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      background: 'white',
                      '&.Mui-focused fieldset': {
                        borderColor: '#4B3E7C',
                        borderWidth: '2px',
                      },
                    },
                  }}
                />
              )}
            </div>

            {/* ── Add Card Information (shown for cash/copay or always) ── */}

            <div className="rounded-xl p-5 bg-[#EAF8F1] border border-[#CFEBDD]">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-5 h-5 rounded-full bg-[#3BAE78] text-white flex items-center justify-center text-xs">
                  ✓
                </div>
                <div className="text-sm font-medium text-gray-800">
                  Add Card Information
                </div>
              </div>

              {/* Saved Payment Methods Dropdown */}
              <div className="mb-4">
                <Autocomplete
                  size="small"
                  options={acPaymentMethods}
                  getOptionLabel={option =>
                    `${option.cardBrand.toUpperCase()} **** ${option.last4} (${option.cardOwner})`
                  }
                  value={selectedPaymentMethod}
                  onChange={(_, newValue) =>
                    handlePaymentMethodChange(newValue)
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Select saved payment method"
                    />
                  )}
                  componentsProps={getAutocompletePopperProps()}
                  sx={{ zIndex: dropdownZIndex }}
                />
              </div>

              {/* Stripe Card Input */}
              <StripeCardInput
                cardholderName={cardholderName}
                onCardholderNameChange={setCardholderName}
                cardComplete={cardComplete}
                onCardCompleteChange={setCardComplete}
                selectedPaymentMethod={selectedPaymentMethod}
                onStripeReady={(stripe, elements) => {
                  setStripeInstance(stripe)
                  setElementsInstance(elements)
                }}
                isSaving={isSavingNewCard}
              />
            </div>

            {/* Terms */}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                background: acAgreed
                  ? 'linear-gradient(135deg, #f3f0ff 0%, #ede9f8 100%)'
                  : '#fafafa',
                borderRadius: '12px',
                padding: '14px 16px',
                border: `1.5px solid ${acAgreed ? '#7A6FA1' : '#e8e4f3'}`,
                transition: 'all 0.15s ease',
                cursor: 'pointer',
              }}
              onClick={() => setAcAgreed(!acAgreed)}
            >
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '5px',
                  border: `2px solid ${acAgreed ? '#7A6FA1' : '#d0ccde'}`,
                  background: acAgreed ? '#7A6FA1' : 'white',
                  flexShrink: 0,
                  marginTop: '1px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {acAgreed && (
                  <span
                    style={{
                      color: 'white',
                      fontSize: '11px',
                      fontWeight: 700,
                    }}
                  >
                    ✓
                  </span>
                )}
              </div>
              <div
                style={{ fontSize: '12px', color: '#4B3E7C', lineHeight: 1.6 }}
              >
                I acknowledge and accept PillarThera's policies and consent to
                receive communications about my account and services.
                <span style={{ color: '#8A82A5' }}>
                  {' '}
                  By joining us, I agree to the Privacy Policy and Terms of Use.
                </span>
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions
          sx={{ px: 3, pb: 3, pt: 1, gap: 1.5, borderTop: '1px solid #f0edf8' }}
        >
          <Button
            onClick={() => setOpenAddContractDialog(false)}
            disabled={acSubmitting}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#8A82A5',
              borderRadius: '10px',
              px: 3,
              border: '1.5px solid #e8e4f3',
              '&:hover': { bgcolor: '#f3f0ff' },
            }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={handleAddContractSubmit}
            disabled={acSubmitting || !acAgreed}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              flex: 1,
              background: 'linear-gradient(135deg, #4B3E7C 0%, #7A6FA1 100%)',
              borderRadius: '10px',
              py: 1.2,
              boxShadow: '0 6px 20px rgba(74,62,124,0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #3d3266 0%, #6c6191 100%)',
              },
              '&.Mui-disabled': { background: '#ede9f8', color: '#b0a8cc' },
            }}
          >
            {acSubmitting ? (
              <>
                <CircularProgress size={16} sx={{ color: 'white', mr: 1 }} />
                Creating...
              </>
            ) : (
              'Complete Booking'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Contract Snackbar */}
      <Snackbar
        open={acSnackbar.open}
        autoHideDuration={3500}
        onClose={() => setAcSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setAcSnackbar(prev => ({ ...prev, open: false }))}
          severity={acSnackbar.severity}
          variant="filled"
          sx={{
            borderRadius: '12px',
            fontWeight: 600,
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          }}
        >
          {acSnackbar.message}
        </Alert>
      </Snackbar>

      {/* ── Sign Contract (DocuSign) Dialog ── */}
      <AgencyDocuSignSigner
        contractId={signContractId}
        open={openSignContractDialog}
        onClose={() => {
          setOpenSignContractDialog(false)
          setSignContractId('')
        }}
        onSigned={() => {
          setOpenSignContractDialog(false)
          setSignContractId('')
          if (activeTab === 'active') fetchTherapists(currentPage, true)
          else if (activeTab === 'unassigned')
            fetchTherapists(currentPage, false, true)
          else fetchTherapists(currentPage)
        }}
        fromBooking={false}
      />
    </div>
  )
}

export default AgencyPatientManagment
